import React, {Fragment,useRef,useEffect,useState,useContext, Suspense, useLayoutEffect, createRef} from 'react'
import {Form, Col, Card} from 'react-bootstrap'
import FORM from '../../../UI/BasicFormControls/FORM'
import GreyCross from "../../../Icons/GreyCross.svg";
import ELEMENTS from '../../../UI/BasicFormControls/ELEMENTS'
import ELEMENT from '../../../UI/BasicFormControls/ELEMENT'
import '../../../UI/css/Canvas.css'
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import {
    modifyCallForAdvanceListview,
    addRowAdvanceListview,
    exportToPDF,
  } from "../../IFormDesignerLayout/RequestLogic";
import style from "../../LeftNavigation/DesignerControls/BasicControls.module.css";
import styles from '../../../UI/css/CANVAS4.module.css'
// import {ClickContext,DropContext,DragContext} from '../../../Resources/AllContextFile'
import {AppContext, Context} from '../../../Resources/CanvasContextFile'
import CSSPreparation from '../../Properties/CSSPreparation.jsx'
import { StyleSheet, css } from 'aphrodite';
import styling from "../../LeftNavigation/DesignerControls/BasicControls.module.css"
import SvgDownloadIcon from "../../../Icons/DownloadIcon"
import SvgSaveIcon from "../../../Icons/SaveIcon"
import {CSSPreparation1} from '../../Properties/CSSPreparation1.jsx';
import DataAdditionPopup from './ListviewProperties/DataAdditionPopup';
import CanvasSubform from './CanvasSubform';
import { updateContextsStates, updateGridContexts } from "../../../Redux/Actions/FormStateActions";
import {functions} from '../ApplicationAPI/applicationApi'
import CreateTemplate from '../../LeftNavigation/PageTemplate/CreatePageTemplate';
import { useTranslation } from 'react-i18next';
import {useDispatch,addContexts,useSelector, updateStateInRedux} from "../../../Redux";
import PrepareCSSClass from '../../IFormDesignerLayout/PrepareCSSClass';
import SessionExpired from "../../SessionExpired";
import ErrorPage from "./ErrorPage";
import LoginHeader from '../../../UI/AdvanceFormControls/LoginHeader/LoginHeader';
import {deepCompareJson} from '../ReUsableLogics';
import ListviewPopUp from './ListviewPopUp';
import AdvanceListviewPopUp from './AdvanceListviewPopUp';
import {toPng} from 'html-to-image'
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import {setAppScreenshotSavedDetails} from '../../../Redux/Actions/AppActions'
import axios from 'axios';
import axios1 from '../../../axios'
import SelectTemplate from '../../LeftNavigation/PageTemplate/SelectTemplate' ;
import {isObjectEmpty, checkEmpty} from "../../../Resources/globalFunctions"
import { executeRouteCriteria, triggerEventCalls } from "../../../ReusableComponents/Events/EventExecutionLogic";
import {formStateStore} from '../../../Redux/Store/store';
import { ResizeObserver, install } from 'resize-observer';
import {isMobile} from 'react-device-detect';
import { Button, CircularProgress, makeStyles } from '@material-ui/core'
import { Loading } from '../../Loading'
import SaveIcon from '@material-ui/icons/Save';
import PicklistValidationModal from './PageProperties/PicklistValidationModal'
import { getGdToken, setDevicePreview , encrypt, decryptMessage, updatePartialJSON, loadArabicImage, getDevice } from '../IFormDesignerLogic'
import cloneDeep from 'lodash-es/cloneDeep';
import { GetState, GetStateFromData } from '../../CustomHooks/CustomHooks.js'
import { BlueButton } from '../../../ReusableComponents/GetButtons/GetButtons.jsx';
import GridModalFooter from '../../../UI/BasicFormControls/TableComponent/GridModalFooter.jsx';
import GridModalHeader from '../../../UI/BasicFormControls/TableComponent/GridModalHeader.jsx';
import GeneratePage from './Marvin/GeneratePage.jsx'
import { useMediaQuery } from '@material-ui/core';
import secureLocalStorage from 'react-secure-storage';
import secureSessionStorage from '../../../utils/secureSessionStorage.js';


const useStyles = makeStyles({
    SubformButtonStyle: {
        height: (style) =>
          style?.current?.height ? `${style?.current?.height}px` : "440px",
          position:"relative",
          left:"96%",
              fontFamily:(style)=>`${
                  style && style["FooterFontFamily"] ? style["FooterFontFamily"]:"Open Sans"
              }`,
            backgroundColor:(style) =>`${
                      style && style["ButtonBackgroundColor"] ? style["ButtonBackgroundColor"]:"rgb(0, 114, 198)"
                  }`,
              fontSize:(style) =>`${
                  style && style["FooterFontSize"] ? `${style["FooterFontSize"]} !important`:"12px !important"
              }`,
              fontWeight:(style) =>`${
                  style && style["FooterFontStyleWeight"] ? `${style["FooterFontStyleWeight"]} !important`:"SemiBold"
              }`,
              fontStyle:(style) =>`${
                  style && style["FooterFontStyle"] ? style["FooterFontStyle"]:"SemiBold"
              }`,
              color:(style) =>`${
                style && style["FooterFontColor"] ? style["FooterFontColor"]:"white"
            }`,
              borderRadius:(style) =>`${
                style && style["subformCornerRadius"] ? `${style["subformCornerRadius"]} !important`:"2px!important"
            }`,
              border:"none"
      },
      SubformButtonStyleCancel: {
        height: (style) =>
          style?.current?.height ? `${style?.current?.height}px` : "440px",
          position:"relative",
          left:"96%",
              fontFamily:(style)=>`${
                  style && style["FooterFontFamily"] ? style["FooterFontFamily"]:"Open Sans"
              }`,
            borderColor:(style) =>`${
                      style && style["ButtonBackgroundColor"] ? `${style["ButtonBackgroundColor"]} !important`:"rgb(0, 114, 198)"
                  }`,
              fontSize:(style) =>`${
                  style && style["FooterFontSize"] ? `${style["FooterFontSize"]} !important`:"12px !important"
              }`,
              fontWeight:(style) =>`${
                  style && style["FooterFontStyleWeight"] ? `${style["FooterFontStyleWeight"]} !important`:"SemiBold"
              }`,
              fontStyle:(style) =>`${
                  style && style["FooterFontStyle"] ? style["FooterFontStyle"]:"SemiBold"
              }`,
              color:(style) =>`${
                style && style["FooterFontColor"] ? style["FooterFontColor"]:"white"
            }`,
              borderRadius:(style) =>`${
                style && style["subformCornerRadius"] ? `${style["subformCornerRadius"]} !important`:"2px !important"
            }`,
              border:"1px solid"
      },
      gridButtons: {
        "& .primaryBtn": {
          color: (prop) => prop.primaryColor,
          backgroundColor: (prop) => prop.primaryBackgroundColor,
          borderColor: (prop) => prop.primaryBorderColor,
    
          "&:focus": {
            boxShadow: (prop) => `0 0 5px 0px ${prop.primaryBorderColor}`
          }
        },
        "& .secondaryBtn": {
          color: (prop) => prop.secondaryColor,
          borderColor: (prop) => prop.secondaryBorderColor,
    
          "&:focus": {
            boxShadow: (prop) => `0 0 5px 0px ${prop.secondaryBorderColor}`
          }
        }
      }
})
const Canvas = (props) => {
    const classes = useStyles(props?.subFormJson?.pageStyle);
    const matches = useMediaQuery("(min-width: 1181px)");
const dispatch=useDispatch()
const gridContexts = GetStateFromData(props.containerId, "data2");

const { subFormListviewJson , openCanvasForPreview , openCanvasForPreviewAdvance , currentAdvanceListviewStateJson } = gridContexts.gridStates;

    const contexts = GetStateFromData(props.containerId);
    const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
    var jwtToken = launchpadKey || undefined;
    const externalIformUrl = document?.URL || document?.baseURI || document?.documentURI;
    const marvinContexts = GetStateFromData(props?.containerId, "marvinData");
    const { isMarvinEnabled, marvinButtonSelected, openMarvinModal } = marvinContexts.marvinStates;
    const reduxContexts=contexts;
    const [loading, setLoading] = useState(false);
    const {fullScreenMode,tempCanWidth,renderCanvas,controlSelected,tempCanWidthDesignPage,tempCanHeightDesignPage,pageLoaded, tempCanHeight, wizard_updated_height, templateLoaded, callTakeScreenshot}  = GetState("fullScreenMode","tempCanWidth","renderCanvas","controlSelected","tempCanWidthDesignPage","tempCanHeightDesignPage","pageLoaded","tempCanHeight", "wizard_updated_height", "templateLoaded", "callTakeScreenshot");
   
    const {getDeviceFromProps_mf ,setApplicationScreenshot , setCanvasTop, widthOfCanvasArea ,setWidthOfCanvas , changeCanvasLayout , changeCanvasLayoutforlistview ,updateJson ,targetForDrop ,drop,
        setSelected,showDataAdditionSection,setShowDataAdditionSection, formState2, loginErrorPage, setLoginErrorPage, changeSectionLayout, 
        // setOpenCanvasForPreview, setAdvanceListviewStateJson , setcurrentAdvanceListviewStateJson ,
        builderMode,activeApplication,applicationScreenshot,microFrontendComponentType,appId,processId,formId,microFrontendData,setAllPages
        , formMataData,globalLoading,globalLoadingMessage,setGlobalLoading,setGlobalLoadingMessage,openProperties,fixedFooter,loginHeaderHeight,appname,setSubFormState,isSubformInPage,isButtonSubformOpen,homePage,
        currentadvanceListview, currentListviewForSubform}=contexts.contexts;

    const currentDesignerGridJson =
      props.openCanvasForSubform === "showDataAdditonSection"
        ? currentListviewForSubform
        : props.openCanvasForSubform === "advanceListviewFromScratch"
        ? currentadvanceListview
        : {};

    const isGridDesignerSubformOpened = props.openCanvasForSubform === "showDataAdditonSection" || props.openCanvasForSubform === "advanceListviewFromScratch";

    var applicationDataVar = contexts?.contexts?.applicationData;
    var activePage = contexts?.contexts?.activePage;
    var activeSubForm = contexts?.contexts?.activeSubForm;
    const isPortal = builderMode === "application";
    const isPortal1 = contexts?.contexts?.isPortal;
    const applicationNameObj = {
        applicationName:
          microFrontendData?.processName ||
          microFrontendData?.newApplicationName ||
          microFrontendData?.applicationName ||
          microFrontendData?.processDefId ||
          appname || "",
        formName:
          microFrontendData?.taskId ||
          microFrontendData?.formName ||
          activePage?.formName ||
          activeSubForm?.fragmentName ||
          microFrontendData?.formId ||
          microFrontendData?.formDefId ||
          ""
      };
    const currentUrl = window?.location?.href
    const imageBaseURL = currentUrl?.includes("openExtInterface") ? "" :
        builderMode === "application" || activePage || activeSubForm || templateLoaded
            ? `${window.apb_backend_app_context}/idesign/getImage/${applicationNameObj.applicationName}/${templateLoaded ? "%20" : applicationNameObj.formName}/${window?.activeCabinet_formbuilder}/`
            : "";

    function filterArray(arrayToFilter){
        var arrayToFilter_var= [];
    
        arrayToFilter?.map(user =>{
            if( arrayToFilter_var.includes(user) ){
            }
            else{
                arrayToFilter_var.push(user);
            }
        })
    
        return arrayToFilter_var;
    }

    // const getUpdatedImageSrc = () => {
    //   let finalSrc;
    //    if(props?.formdata?.finalStyles?.backgroundImage){
    //     let background = props?.formdata?.finalStyles?.backgroundImage
    //     // const src = background.replace(/^url\("(.+)"\)$/, '$1');
    //     const src = background.replace(/^url\("(.*)"\)$/, '$1')
    //     console.log(src)
    //     finalSrc = src ? `url("${src}${loadArabicImage(imageBaseURL)}")` : src
    //     console.log(finalSrc)
    //   }
    //   return finalSrc || ""
    // }

  function getUpdatedImageSrc() {
    var styles = props && props.formdata && props.formdata.finalStyles;
    if (!styles) return "";

    var background = styles.backgroundImage;
    if (!background || typeof background !== "string") return "";

    // === Helper: Append Arabic suffix as in your original ===
    function appendArabicSuffix(originalUrl) {
      try {
        var suffix = loadArabicImage(imageBaseURL) || "";
        if (!suffix) return originalUrl;
        if (originalUrl.indexOf(suffix) !== -1) return originalUrl;

        var hasQuery = originalUrl.indexOf("?") !== -1;
        var joiner = hasQuery ? "&" : "?";
        var cleanedSuffix = suffix.replace(/^[?&]/, "");

        return originalUrl + joiner + cleanedSuffix;
      } catch (e) {
        return originalUrl + (loadArabicImage(imageBaseURL) || "");
      }
    }

    // === Helper: Replace the *cabinet* path segment with window?.activeCabinet_formbuilder ===
    function replaceCabinetSegment(originalUrl) {
      try {
        var cabinetName = (typeof window !== "undefined" && window && window.activeCabinet_formbuilder) || "";
        if (!cabinetName) return originalUrl;

        // Split query part (preserve it exactly as-is)
        var qIndex = originalUrl.indexOf("?");
        var base = qIndex === -1 ? originalUrl : originalUrl.slice(0, qIndex);
        var query = qIndex === -1 ? "" : originalUrl.slice(qIndex);

        // We only operate on path-like URLs. Keep protocol-less/relative URLs as-is too.
        // Safely find the last two '/' to isolate: ".../<cabinet>/<filename>"
        var lastSlash = base.lastIndexOf("/");
        if (lastSlash <= 0) return originalUrl; // no slash or malformed

        // Find the previous '/' before the filename
        var prevSlash = base.lastIndexOf("/", lastSlash - 1);
        if (prevSlash <= 0) return originalUrl;

        // Extract filename and cabinet segments
        var filename = base.slice(lastSlash + 1); // "5338629b-....jpg"
        if (!filename) return originalUrl;

        // Basic guard: operate only when filename looks like an image file
        var isImage = /\.(png|jpe?g|webp|gif|svg|avif)$/i.test(filename);
        if (!isImage) return originalUrl;

        // Replace the cabinet segment
        var replaced =
          base.slice(0, prevSlash + 1) + encodeURIComponent(cabinetName) + base.slice(lastSlash);

        return replaced + query;
      } catch (e) {
        // On any error, fall back to original URL
        return originalUrl;
      }
    }

    // === Main: rewrite all url(...) instances inside the CSS string ===
    var updated = background.replace(
      /url\(\s*(['"]?)(.*?)\1\s*\)/gi,
      function (_match, quote, url) {
        var q = quote || "";
        var cleanUrl = (url || "").trim();

        // First, replace the cabinet segment
        var withCabinet = replaceCabinetSegment(cleanUrl);

        // Then, append Arabic suffix if applicable
        var finalUrl = appendArabicSuffix(withCabinet);

        return "url(" + q + finalUrl + q + ")";
      }
    );

    return updated;
}
    
    const [loggedIn , setLoggedIn] = useState(true);
    const showLoginHeader = useRef(true);
    const [loginHeaderExist, setLoginHeaderExist] = useState(false);
    const [loginHeaderState, setLoginHeaderState] = useState({});
    const appScreenshotSavedDetails=useSelector((state)=>state.appScreenshotSavedDetails)
    const[selectedTemplateName,setSelectedTemplateName] = useState("")
    const[pageProperties, setPageProperties] = useState({})
    const gdCall = useSelector((state) => state["afterFormLoad"]);
    const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";  
    const [emptyScreen,setEmptyScreen]=useState(true);
    const [updatedImage, setUpdatedImage] = useState(() => getUpdatedImageSrc())

    const containerRef = useRef(null);

    function handleClose(){
        setShowPageTemplate((prev)=>{return{...prev, open:false}})
    }

    if(window.location.href.includes("interfaceDesigner") || window.location.href.includes("pmWebDesigner") || window.location.href.includes("pmWebPreview") || !props?.previewmode) {
      window.changeEmptyScreen = (bool) => {
        window.emptyScreen1 = bool
        setEmptyScreen(bool)
      }
    }
    
    let buttonJson = null;

    function findRouteCriteriaButton(formStatejson) {
        if(formStatejson){
          if(formStatejson?.event?.Events?.Click?.Command?.Name === "RouteCriteria"){
            buttonJson = formStatejson;
          } else {
            if(formStatejson.children && formStatejson.children.length){
              formStatejson.children.map(child => {
                if(child){
                  if(child?.event?.Events?.Click?.Command?.Name === "RouteCriteria"){
                      buttonJson = child;
                    } else if(isObjectEmpty(buttonJson || {})) {
                        findRouteCriteriaButton(child);
                    }
                }
              });
            }
          }
          return buttonJson;
        }
      }

    const onEnterClickOnLogin = (event) => {
        if (event.keyCode === 13) {
            if(!((activePage?.formId !== applicationDataVar?.defaultFormId) && activePage?.formId)){ // check for login page.
                const formState = JSON.parse(activePage?.formBuffer || null);
                const buttonJson = findRouteCriteriaButton(formState);

                if(buttonJson) {
                    const userNameTextboxId = buttonJson?.event?.Events?.["Click"]?.Command?.Parameters?.UserName || null;
                    const passWordTextboxId = buttonJson?.event?.Events?.["Click"]?.Command?.Parameters?.Password || null;

                    const userNameTextbox = document.getElementById(userNameTextboxId);
                    const passWordTextbox = document.getElementById(passWordTextboxId);

                    if(userNameTextboxId && passWordTextboxId) {
                        userNameTextbox.blur();
                        passWordTextbox.blur();
                    }
                    setTimeout(() => {
                        executeRouteCriteria(reduxContexts, buttonJson.event, {id: buttonJson.id});
                    }, 400);
                }
              }
        }
    }
    let canvasScrollPosition=useRef(); 
    
    useEffect(() => {
        if(callTakeScreenshot) {
            dispatch(updateStateInRedux({name: "callTakeScreenshot", value: false}));
            (async() => {
              var formName;
              if (builderMode !== "application" && builderMode !== "preview") {
                formName = window?.WDeskData?.Processname;
              } else {
                formName = formState2?.formName;
              }
              let screenshotBase64 = "";
              const screenshotBase64Promise = takeScreenshot();
              screenshotBase64Promise.then((result) => {
                screenshotBase64 = result;

                const canvasElement = document.getElementById("design_page");
                let canvasElementWidth;
                let canvasElementHeight;

                if (canvasElement) {
                  canvasElementWidth =
                    canvasElement.getBoundingClientRect().width;
                  canvasElementHeight =
                    canvasElement.getBoundingClientRect().height;
                }
                exportToPDF({
                  formName,
                  imageData: screenshotBase64,
                  height: canvasElementHeight,
                  width: canvasElementWidth,
                });
              });
            })();
        }
    },[callTakeScreenshot])
    
    useEffect(()=>{
        if((props?.openCanvasForSubform!=="advanceListviewFromScratch" && props?.openCanvasForSubform!=="showDataAdditonSection"  && props?.openCanvasForSubform!=="subform" ) && document.getElementById("mainCanvas") && openProperties)
        {
            canvasScrollPosition.current=document.getElementById("mainCanvas")?.scrollTop;
        //   console.log(document.getElementById("mainCanvas")?.scrollTop,canvasScrollPosition.current)
        }
        
    },[openProperties])

    useEffect(()=>{
        if(canvasScrollPosition.current!==undefined && (props?.openCanvasForSubform!=="advanceListviewFromScratch" && props?.openCanvasForSubform!=="showDataAdditonSection"  && props?.openCanvasForSubform!=="subform" ) && document.getElementById("mainCanvas") && openProperties===false && !props?.previewmode){
        
            document.getElementById("mainCanvas")?.scrollTo(0,canvasScrollPosition?.current);
    
        }
    },[openProperties,props?.openCanvasForSubform])
    
    useEffect(() => {
        window.addEventListener("keyup", onEnterClickOnLogin);

      return () => {
        window.removeEventListener('keyup', onEnterClickOnLogin);
      }
    }, [applicationDataVar, contexts.gdtoken, contexts.witoken])
    

    useEffect(() => {

        var headerJsonString = applicationDataVar?.headerJSON;
        var islogin = applicationDataVar?.islogin;

        try{
            if(islogin==='Y'){
                showLoginHeader.current = true;
            } else {
                showLoginHeader.current = false;
            }
        } catch(e){
            console.error('@ application Data issue ',e);
        }

    },[applicationDataVar]);
    useEffect(()=>{
        if(props?.previewmode){
            document.getElementById("subformId")?.focus();
            document.getElementById("advanceListviewFromScratchId")?.focus();
            document.getElementById("design_page")?.focus();
        }
       },[])

    const findLoginHeader = ( formJson) => {
        if(formJson?.id==='LoginHeader'){
            return formJson;
        } else {
            let returnJson;
            let jsonChildren = formJson?.children;
            if(jsonChildren){
                for(let i=0;i<jsonChildren.length;i++){
                    if (jsonChildren[i]?.id==='LoginHeader'){
                        returnJson = jsonChildren[i];
                        return returnJson;
                    } else {
                        let found = findLoginHeader(jsonChildren[i]);
                        if(found) return found;
                    }
                }
                return returnJson;
            }
        }
    }

    // const getUpdatedImageSrc = () => {
    //   let finalSrc;
    //   if(props?.formdata?.finalStyles?.backgroundImage){
    //     let background = props?.formdata?.finalStyles?.backgroundImage
    //     const src = background.replace(/^url\("(.+)"\)$/, '$1');
    //     finalSrc = `url("${src}${loadArabicImage(imageBaseURL)}")`
    //     console.log(finalSrc)
    //   }
    //   return finalSrc || ""
    // }

function getUpdatedImageSrc() {
  var styles = props && props.formdata && props.formdata.finalStyles;
  if (!styles) return "";

  var background = styles.backgroundImage;
  if (!background || typeof background !== "string") return "";

  // === Helper: Append Arabic suffix as in your original ===
  function appendArabicSuffix(originalUrl) {
    try {
      var suffix = loadArabicImage(imageBaseURL) || "";
      if (!suffix) return originalUrl;
      if (originalUrl.indexOf(suffix) !== -1) return originalUrl;

      var hasQuery = originalUrl.indexOf("?") !== -1;
      var joiner = hasQuery ? "&" : "?";
      var cleanedSuffix = suffix.replace(/^[?&]/, "");

      return originalUrl + joiner + cleanedSuffix;
    } catch (e) {
      return originalUrl + (loadArabicImage(imageBaseURL) || "");
    }
  }

  // === Helper: Replace the *cabinet* path segment with window?.activeCabinet_formbuilder ===
  function replaceCabinetSegment(originalUrl) {
    try {
      var cabinetName = (typeof window !== "undefined" && window && window.activeCabinet_formbuilder) || "";
      if (!cabinetName) return originalUrl;

      var qIndex = originalUrl.indexOf("?");
      var base = qIndex === -1 ? originalUrl : originalUrl.slice(0, qIndex);
      var query = qIndex === -1 ? "" : originalUrl.slice(qIndex);

      var lastSlash = base.lastIndexOf("/");
      if (lastSlash <= 0) return originalUrl;

      var prevSlash = base.lastIndexOf("/", lastSlash - 1);
      if (prevSlash <= 0) return originalUrl;

      var filename = base.slice(lastSlash + 1);
      if (!filename) return originalUrl;

      var isImage = /\.(png|jpe?g|webp|gif|svg|avif)$/i.test(filename);
      if (!isImage) return originalUrl;

      var replaced =
        base.slice(0, prevSlash + 1) + encodeURIComponent(cabinetName) + base.slice(lastSlash);

      return replaced + query;
    } catch (e) {
      return originalUrl;
    }
  }

  // === Main: rewrite all url(...) instances inside the CSS string ===
  var updated = background.replace(
    /url\(\s*(['"]?)(.*?)\1\s*\)/gi,
    function (_match, quote, url) {
      var q = quote || "";
      var cleanUrl = (url || "").trim();

      // ✅ NEW: Replace /formBuilder with dynamic backend context
      if (typeof window !== "undefined" && window.apb_backend_app_context) {
        cleanUrl = cleanUrl.replace(
          /^\/formBuilder/,
          window.apb_backend_app_context
        );
      }

      // Existing logic
      var withCabinet = replaceCabinetSegment(cleanUrl);
      var finalUrl = appendArabicSuffix(withCabinet);

      return "url(" + q + finalUrl + q + ")";
    }
  );

  return updated;
}

 

    var previewMode = props.previewmode;  
    var containerId=props.containerId;
    var device  = props.device;
    var handleReorderStart  = props.handleReorderStart;
    var handleReOrderDrag  = props.handleReOrderDrag;
    var handleReorderDrop  = props.handleReorderDrop;
    var setDragging  = props.setDragging;
    var handleRemoveGrid  = props.handleRemoveGrid;
    var dragging  = props.dragging;
    var formdata1 = props.formdata;
    var formdata  = props.formdata;
    // const [formdata, setFormData] = useState(props.formdata);
    var openCanvasForSubform  = props.openCanvasForSubform;
    var handleSubForm  = props.handleSubForm;
    var selectedControl= props.selectedControl;

    const shadeRef=useRef(null);

    var themeData = formState2?.theme;
    var spacing = "Compact" ;

    if(themeData && themeData?.['BasicTheme'] && themeData?.['BasicTheme']?.['Spacing']){
      spacing = themeData?.['BasicTheme']?.['Spacing'];
    }
    var jsonForSpacingDiv = {};
    var spacingBetweenControls;

    if(spacing=='Compact'){
        spacingBetweenControls='0px !important';
    }else if(spacing=='Regular'){
        spacingBetweenControls='5px !important';
    }else if(spacing=='Expanded'){
        spacingBetweenControls='10px !important';
    }

    var jsonForSpacingLabel = {};
    var spacingBetweenLabel;

    if(spacing=='Compact'){
        spacingBetweenLabel='4pt !important';
    }else if(spacing=='Regular'){
        spacingBetweenLabel='6pt !important';
    }else if(spacing=='Expanded'){
        spacingBetweenLabel='8pt !important';
    }

    var jsonForControlFontSize = {};
    var fontSizeBasic = "12pt" ;

    if(themeData?.['BasicTheme']?.['FontSize']){
        fontSizeBasic = themeData?.['BasicTheme']?.['FontSize'] ;
    }
    jsonForSpacingDiv['margin-bottom']=spacingBetweenControls; 
    jsonForSpacingLabel['margin-bottom']=spacingBetweenLabel;
    jsonForControlFontSize['font-size']=fontSizeBasic;

    const { t } = useTranslation();

    const [canvasWidth,setCanvasWidth] = useState((window.innerWidth-330));
    let [addContainer,setAddContainer] = useState(false)
    let [generatePage,setGeneratePage] = useState(false)

    useEffect(() => {
        window.addEventListener('resize', handleLayoutforPreview, true);
        return () => {
            window.removeEventListener('resize', handleLayoutforPreview, true);
        };
    }, []);

    useEffect(() => {
      let currentUrl = getUpdatedImageSrc()
      setUpdatedImage(currentUrl)
    }, [props?.formdata?.finalStyles?.backgroundImage])

    const overshade={
        position:"absolute",
        top:"0",
        left:"0",
        height:"100%",
        width:"99%",
        zIndex:"2",
        opacity:"0.1",
        pointerEvents:"none",
        background: `repeating-linear-gradient(to right,
            grey,
            grey ${(canvasWidth*(15/192))}px,
            white ${canvasWidth/192}px,
            white ${(canvasWidth/12)}px)`,
        margin:"6px"
    }
    
    function handleScreenResize(){
        if(props?.previewmode){
            setCanvasWidth(tempCanWidth-16);
        }        
    }   
   
    const [imageSrc, setImageSrc] = useState();
    const [styleData, setStyling]=useState({});
    const [preparecss, setpreparecss] = useState(false);
    const [oldStyle, setOldStyle] = useState();


    const imageRef = createRef(null);
    const imageRef2 = createRef(null);
    const imageRef3 = createRef(null);
    const imageRef4 = createRef(null);
    //const [image, takeScreenshot] = useScreenshot();
    
    const [preDev, setPreDev] = useState("web");
    const [dev, setDev] = useState("web");

    // const [tempCanWidth, setTempCanWidth] = useState(0);

    
    const getImage =  async () => {
      const sourceNode = document.querySelector("#canvasId #canvas_id_screenshot");

      if (!sourceNode) {
        return "";
      }
      const cloneHost = document.createElement("div");
      const clonedNode = sourceNode.cloneNode(true);

      cloneHost.style.position = "fixed";
      cloneHost.id = 'cloneDiv';
      cloneHost.style.top = "0";
      cloneHost.style.left = "-100000px";
      cloneHost.className = 'formBuilder_main_app';
      cloneHost.style.pointerEvents = "none";
      cloneHost.style.zIndex = "-1";
      cloneHost.style.background = "transparent";
      clonedNode.style.width = `${sourceNode.getBoundingClientRect().width}px`;
      cloneHost.appendChild(clonedNode);
      document.body.appendChild(cloneHost);

      try {
        const sourceDivs = [clonedNode, ...clonedNode.querySelectorAll("div")];
        const headers = [clonedNode, ...clonedNode.querySelectorAll("header")];
        headers.forEach((header) => {
            if (header.classList.contains('animate_header')) {
              header.classList.remove('animate_header');
            }
        })
        sourceDivs.forEach((srcDiv, index) => {
          const cloneDiv = srcDiv;
          if (!cloneDiv) {
            return;
          }

          // if (hasOverflow) {
            if(cloneDiv.style.maxHeight || cloneDiv.style.minHeight) {
              cloneDiv.style.height = ``;
              cloneDiv.style.maxHeight = "";
              cloneDiv.style.minHeight = "";
            }
        });

        const imageWidth = Math.ceil(Math.max(clonedNode.scrollWidth, clonedNode.getBoundingClientRect().width));
        const imageHeight = Math.ceil(Math.max(clonedNode.scrollHeight, clonedNode.getBoundingClientRect().height));
      try {
        const res = await toPng(clonedNode, {
          width: imageWidth,
          height: imageHeight,
          cacheBust: true,
        });

        setApplicationScreenshot(res);
        return res;
        } catch (error) {
          console.error("Error generating image:", error);
        }
      } finally {
        if (cloneHost.parentNode) {
          cloneHost.parentNode.removeChild(cloneHost);
        }
      }
    }

    useEffect(() => {
        window.afb_isFormModified = false
    },[]);

    // window.isFormModified = function () {
    //     return ((window && (window?.afb_isFormModified !== undefined)) ? window?.afb_isFormModified : null)
    // }

    // window.setFormMoified = function (props) {
    //     window.afb_isFormModified = props;
    // }

    const takeScreenshot = async () => {
      const appScreenshotDataObj = appScreenshotSavedDetails.find(
        (item) =>
          item.componentType === microFrontendComponentType &&
          item.formDefId === microFrontendData?.formDefId &&
          item.processId === processId &&
          item.formId === formId &&
          item.fragementId === microFrontendData?.fragementId &&
          item.appId === appId
      );
      const appScreenshotDataObjIndex = appScreenshotSavedDetails.findIndex(
        (item) =>
          item.componentType === microFrontendComponentType &&
          item.formDefId === microFrontendData?.formDefId &&
          item.processId === processId &&
          item.formId === formId &&
          item.fragementId === microFrontendData?.fragementId &&
          item.appId === appId
      );

      if (appScreenshotDataObj && appScreenshotDataObj?.isScreenshotTaken){
        return appScreenshotDataObj.screenshot || "";
      } else {
        if (activeApplication?.defaultFormId === activePage?.formId) {
          const image_out = await getImage();
          const newAppSsData = [...appScreenshotSavedDetails];
          newAppSsData.splice(appScreenshotDataObjIndex, 1, {
            ...appScreenshotDataObj,
            isScreenshotTaken: true,
            screenshot: image_out,
          });
          dispatch(setAppScreenshotSavedDetails({key: containerId, value: [...newAppSsData]}));

          return image_out;
        }

        if (activeSubForm?.fragmentId) {
          const image_out = await getImage();
          const newAppSsData = [...appScreenshotSavedDetails];
          newAppSsData.splice(appScreenshotDataObjIndex, 1, {
            ...appScreenshotDataObj,
            isScreenshotTaken: true,
            screenshot: image_out,
          });
          dispatch(setAppScreenshotSavedDetails({key: containerId, value: [...newAppSsData]}));

          return image_out;
        }

        if(builderMode === "application"){
            if(activePage?.formId){
                const image_out = await getImage();
          const newAppSsData = [...appScreenshotSavedDetails];
          newAppSsData.splice(appScreenshotDataObjIndex, 1, {
            ...appScreenshotDataObj,
            isScreenshotTaken: true,
            screenshot: image_out,
          });
          dispatch(setAppScreenshotSavedDetails({key: containerId, value: [...newAppSsData]}));

          return image_out;
            }
        }
      }
    };
    
    if(formdata && formdata?.pageStyle !== oldStyle){
        setpreparecss(false);
        setOldStyle(formdata?.pageStyle); 
    }
    var styleSheet = StyleSheet.create({
        styling: styleData
    });

    function setStylingData(stylingData) {
        setStyling(stylingData);
        setpreparecss(true);
    }

    var jsonForOverlay = {};
    var jsonForOverlayTitle = {};
    var jsonForButtonAlignment = {};

    if(openCanvasForSubform === "advanceListviewFromScratch"){ }

    const OverlaypreparedStyle1 = CSSPreparation1(jsonForOverlay);
    var overlaySyleSheet1 = StyleSheet.create({
       styling: OverlaypreparedStyle1
    });
    const OverlaypreparedStyle2 = CSSPreparation1(jsonForOverlayTitle);
    var overlaySyleSheet2 = StyleSheet.create({
       styling: OverlaypreparedStyle2
    });
    const OverlaypreparedStyle3 = CSSPreparation1(jsonForButtonAlignment);
    var overlaySyleSheet3 = StyleSheet.create({
       styling: OverlaypreparedStyle3
    });
       

    var canvas_bodyStyle = {
        display:'block',
    };

    useEffect(() => {
        if(formState2.containerControl === "wizard_h" || formState2.containerControl === "wizard_v" || formState2.containerControl === "sidenavigation") {
            if(fixedFooter === true || fixedFooter === 'true')
                document?.getElementById("design_page")?.scrollTo(0,0);
        }
    },[fixedFooter]) 


    
      
  /******start*****************************UPDATING ENCRPTED DBLINKING STRING IN CASE IT IS ENC USING OLD METHODS******************************************* */
  const [encr_dbquery_new, setencr_dbquery_new]= useState( undefined);

  const encr_dbquery_new_temp= useRef({});

  const encr_length_count= useRef(0);


  async function getDecryptedstr( encr_str , key ){
    if(encr_str && key){
      const decr_str = await decryptMessage(encr_str , updateEncypted_str , key );
      // setdecr_dbquery(decr_str);
    }
  }

  async function updateEncypted_str(decr_str, key ){
    console.log("updateEncypted_str called textbox");
    
    let getcallbackstr = await decr_str;
    const encr_str_new = await encrypt(getcallbackstr);

    encr_dbquery_new_temp.current = {
            ...encr_dbquery_new_temp.current, 
            [key] : encr_str_new 
        };

    let newEventobj = JSON.parse( JSON.stringify( props?.formdata?.event?.Events ) );

    if( encr_length_count.current === Object.keys( newEventobj )?.length ){

        let changedEventObj = newEventobj;

        for(let i=0; i< Object.keys( newEventobj )?.length ; i++) {

            if(Object.values( newEventobj )?.[i]?.DBLinking){

                changedEventObj ={ ...changedEventObj, 
                    [ Object.keys( newEventobj )[i] ] : {...Object.values( newEventobj )[i], 
                        "DBLinking": [ { ...Object.values( newEventobj )[i]?.DBLinking[0] , 
                            "Query": encr_dbquery_new_temp.current[ Object.keys( newEventobj )[i] ]
                        } ]
                    } }
                    
            }
        }
        
        setencr_dbquery_new(changedEventObj);
    }
  }

    useEffect(()=>{
      if(props?.previewmode){
      }
      else{
        if(props?.formdata?.event?.Events){

            const newEventobj = JSON.parse( JSON.stringify( props.formdata.event.Events ) );
            
            Object.values(newEventobj).map((obj, index ) =>{
                
                encr_length_count.current = encr_length_count.current +1;
                
                if(Object.keys(obj)[index] === "DBLinking" && obj?.DBLinking?.[0]?.Query){
                    getDecryptedstr( obj?.DBLinking?.[0]?.Query , Object.keys(newEventobj)[index] );
                }
                
            })
        }
      }
      
    },[formdata?.event])

    useEffect(()=>{
      if(props?.previewmode){
      }
      else{

        // props.formdata.event.Events.load
          // updateformstate here 
          if(props?.formdata?.event?.Events && encr_dbquery_new){
              let old_control_json = JSON.parse( JSON.stringify( props?.formdata ) );
              old_control_json.event.Events = encr_dbquery_new;
              updatePartialJSON( old_control_json.id, old_control_json);
            }
        }
      
    },[encr_dbquery_new])


  /******end*****************************UPDATING ENCRPTED DBLINKING STRING IN CASE IT IS ENC USING OLD METHODS******************************************* */


    useEffect(()=>{
        const gdtoken=formStateStore.getState()?.data?.find(json => json.key === containerId)?.gdtoken;
        console.log ("verbose" , gdtoken, props.previewmode, pageLoaded, gdCall, props.formdata)
        if (props.previewmode && gdtoken && gdtoken!=="" && pageLoaded && gdCall && props.formdata && (Object.keys(props.formdata).length > 0)){
            formStateStore.dispatch(updateStateInRedux({"name": "pageLoaded", "value": false}));  
            var e = {
                type: "load",
              };
              if (
                props.formdata &&
                props.formdata.event &&
                props.formdata.event.Events &&
                props.formdata.event.Events.load
              ) {
                triggerEventCalls(e,{id:"root"},props.formdata.event,props.formdata.elem_type,()=>{}, contexts,props.containerId,props.formdata,"load");
    //   triggerEventCalls(event, elementRefrence.current, props.data.event, props.data.elem_type, showAlertConfirmNotifications, reduxContexts,props.containerId,props.data,"Click");

              }
        }
        setEmptyScreen(true)
    },[activePage,activeSubForm, props.formdata.event, gdCall])
      
       
    const [updatedOnce, setOnceUpdated]=useState(false);
    // UseLess

    
    function changeLayoutonLoad(){
        if(props.device==="mobile"){
            changeCanvasLayout(1,"mobile","none");
        }
        if(props.device==="tablet"){
            changeCanvasLayout(2,"tablet","none");
        }
        if(props.device==="web"){
            changeCanvasLayout(3,"web","none");
        }
        else if (!props.device){
            // changeCanvasLayout(3,"web","none");
        }
        setOnceUpdated(true);
    }

    useEffect(()=>{
      if(updatedOnce!==false && formState2 && !isObjectEmpty(formState2)){
            setOnceUpdated(false);
        }
    },[activePage, activeSubForm])

    useEffect(()=>{
      if(getDeviceFromProps_mf===false && updatedOnce===false&& !externalIformUrl?.includes("afb_subform")  && formState2 && !isObjectEmpty(formState2)){
          changeLayoutonLoad();
        }      
    },[formState2, props?.landscapeView]);

    //     if(props.device==="mobile")
    //             {
    //                 // props?.setDevice("mobile");
    //                 changeCanvasLayout(1,"mobile","none");
    //             setOnceUpdated(true);

    //             }

    //             if(props.device==="tablet")
    //             {
    //                 changeCanvasLayout(2,"tablet","none");
    //                 // props?.setDevice("tablet");
    //             setOnceUpdated(true);

    //             }
    //             if(props.device==="web")
    //             {
    //                 changeCanvasLayout(3,"web","none");
    //                 // props?.setDevice("web");
    //             setOnceUpdated(true);

    //             }
    //             else if (!props.device){
    //                 changeCanvasLayout(3,"web","none");
    //                 // props?.setDevice("web");
    //             setOnceUpdated(true);
    //             }
    // }
    // useEffect(()=>{
    //     if(updatedOnce!==false && formState2 && !isObjectEmpty(formState2)){
    //         setOnceUpdated(false);
    //     }
    // },[activePage])

    // useEffect(()=>{
    //     if(getDeviceFromProps_mf===false && updatedOnce===false && formState2 && !isObjectEmpty(formState2)){
    //         changeLayoutonLoad();
    //     }      
    // },[formState2]);


    // UseLess
    // useLayoutEffect(()=>{
    //     if(getDeviceFromProps_mf===true){
    //         var canvasElement = document.getElementById("canvasId");
    //         const endValue = props.formdata?.style?.["Breakpoint"]?.[props.device]?.EndValue-10
    //         canvasElement.style.width = endValue + 'px';
    //     }
    // });

    useLayoutEffect(()=>{
        var canvasElement = document.getElementById("canvasId");
        if(canvasElement?.style?.width == "" || props?.formdata?.style?.["Breakpoint"]?.["Desktop"]?.EndValue == undefined){
            if(props?.device === "web" ) {
                // const endValueWeb = props?.formdata?.style?.["Breakpoint"]?.["Desktop"]?.EndValue - 10
                // canvasElement.style.width = endValueWeb + 'px';
                canvasElement.style.width = "90vw";
            } else if(props.device === "tablet") {
                const endValueTab = props?.formdata?.style?.["Breakpoint"]?.["Tab"]?.EndValue - 10
                canvasElement.style.width = endValueTab + 'px';
            } else if(props.device === "mobile") {
                const endValueMobile = props?.formdata?.style?.["Breakpoint"]?.["Mobile"]?.EndValue - 10
                canvasElement.style.width = endValueMobile + 'px';
            }
        }
    });

    useLayoutEffect(()=> {
        var canvasElement = document.getElementById("canvasId");
        if(!previewMode){
            if(props.formdata.style){
                // props.formdata.style["CanvasWidth"] = isSafariBrowser() ? 1920 :widthOfCanvasArea;
                // props.formdata.style["WidthOfCanvas"] = isSafariBrowser() ? 1920 : widthOfCanvasArea;
                props.formdata.style["CanvasWidth"] = widthOfCanvasArea;
                props.formdata.style["WidthOfCanvas"] = widthOfCanvasArea;
            }            
            canvasElement.style.width =  widthOfCanvasArea + 'px';
            // canvasElement.style.width =  isSafariBrowser() ? '1920px' : widthOfCanvasArea + 'px';
        }
    },[widthOfCanvasArea])

    function agentHas(keyword) {
        return window.navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
        }
    
     let isSafariBrowser = function isSafari() {
      return (!!window.ApplePaySetupFeature || !!window.safari) && agentHas("Safari") && !agentHas("Chrome") && !agentHas("CriOS");
      }
      
    
    const tabletView={
        width: props?.formdata?.style?.WidthOfTablet !== undefined ? props?.formdata?.style?.WidthOfTablet + "px" : "754px"
    };
    
    const mobileView={
        width: props?.formdata?.style?.WidthOfMobile !== undefined ? props?.formdata?.style?.WidthOfMobile + "px": "440px"
    };
    
    const webView={
        width: isSafariBrowser() ? '1922px'  : props?.formdata?.style?.WidthOfWeb !== undefined ? props?.formdata?.style?.WidthOfWeb + "px" : "90vw"
    };
    
    const [currentDeviceType, setCurrentDeviceType] = useState(props.device);
    const showFooter = currentDesignerGridJson?.popupStyle?.["ShowFooter"] !== "false";
    const showFooterWhenDisabled = currentDesignerGridJson?.popupStyle?.["ShowFooterWhenDisabled"] !== "false";

    var currentDeviceCanvas=props.device;
    useEffect(()=>{
        currentDeviceCanvas=props.device;
    },[props.device])


    // UseLess
    useEffect(()=>{
         var tempdata = props.formdata;
        if(Object.keys(tempdata).length!==0 && !props?.previewmode){
            draggingCanvas();
        }
    },[props.formdata]);

    function draggingCanvas(){

        var canvasElement = document.getElementById("canvasId");
        var resizerHandler  = document.getElementById("resizeCanvasDrag");
        let preDev;
    
        if(canvasElement!==null){
            var prevWidthInPx = tempCanWidth;
        }
        if(resizerHandler !==null){
            if(document.getElementById("canvasId")?.getAttribute("listener") !== "true"){
                resizerHandler.addEventListener('mousedown', mousedown);
                document.getElementById("canvasId").setAttribute("listener", true);
            }
        }

        var resizeColumnWidth = true
        let requestAnimationFrame;
    
        function mousedown(e){
            if(resizeColumnWidth === false){
                resizeColumnWidth = true
            }
            if(resizeColumnWidth){
                prevWidthInPx = canvasElement.offsetWidth;
            let widthOfCanvas;
                if(translationStyles1){
                    widthOfCanvas = canvasElement.getBoundingClientRect().right - e.pageX;
                }
                else{
                    widthOfCanvas = e.pageX - canvasElement.getBoundingClientRect().left;
                }
                canvasElement.style.width = widthOfCanvas+'px';
                e.preventDefault();
    
                if(widthOfCanvas <= parseInt(props?.formdata?.style?.Breakpoint?.Mobile?.EndValue) && widthOfCanvas >= parseInt(props?.formdata?.style?.Breakpoint?.Mobile?.StartValue)){
                    preDev = "mobile"
                } 
                if(widthOfCanvas <= parseInt(props?.formdata?.style?.Breakpoint?.Tab?.EndValue) && widthOfCanvas >= parseInt(props?.formdata?.style?.Breakpoint?.Tab?.StartValue)){
                    preDev = "tablet"
                }  
                if(widthOfCanvas <= parseInt(props?.formdata?.style?.Breakpoint?.Desktop?.EndValue) && widthOfCanvas >= parseInt(props?.formdata?.style?.Breakpoint?.Desktop?.StartValue)){
                    preDev = "web"
                }  
    
                window.addEventListener('mousemove', resize);
                window.addEventListener('mouseup', stopResize);
                props.setOpenScale(true);
            }
            
        }
    
        function resize(e){
            var widthOfCanvas;
            if(translationStyles1){
                widthOfCanvas = canvasElement.getBoundingClientRect().right - e.pageX;
            }
            else{
                widthOfCanvas = e.pageX - canvasElement.getBoundingClientRect().left;
            }
            var endValue=parseInt(props.formdata.style["Breakpoint"]["Mobile"]["StartValue"]);
            if(widthOfCanvas > endValue){
                canvasElement.style.width = widthOfCanvas+'px';
            }
            requestAnimationFrame = window.requestAnimationFrame(resize)
        }

        function stopResize(e) {
            if(resizeColumnWidth){
                resizeColumnWidth = false
                props.setOpenScale(false);
                window.removeEventListener('mousemove', resize);
                window.removeEventListener('mouseup', stopResize);
                window.cancelAnimationFrame(requestAnimationFrame)

                const canvasEl = document.querySelector("#canvasId");

                if((canvasEl)) {
                    const resizeDiv = document.querySelector("#resizeCanvasDrag");
                    const isTouchDeviceCheck = isTouchDevice();
        
                    const currentWidth = canvasEl.getBoundingClientRect().width;
        
                    if (currentWidth < 20 || isTouchDeviceCheck) {
                        if(resizeDiv) resizeDiv.style.display = "none";
                        canvasEl.style.border = "none";
                    } else {
                        if(resizeDiv) resizeDiv.style.display = "block";
                        canvasEl.style.border = "1px solid rgba(0,0,0,.125)";
                    }
                }
           
                if(getDeviceFromProps_mf===false){
    
                    if(props.formdata.style)
                    {
                        props.formdata.style["WidthOfCanvas"]=parseInt(canvasElement.getBoundingClientRect().width, 10);
                    }
                    let widthOfCanvas = parseInt(canvasElement.getBoundingClientRect().width, 10);
    
                    setWidthOfCanvas(widthOfCanvas);
    
                    if(widthOfCanvas >= parseInt(props?.formdata?.style?.Breakpoint?.Mobile?.StartValue) 
                    && widthOfCanvas < parseInt(props?.formdata?.style?.Breakpoint?.Mobile?.EndValue))
                    {
                        props.formdata.style["WidthOfMobile"] = widthOfCanvas;
                        if(preDev!=="mobile")
                        {
                            changeCanvasLayout(1,"mobile",preDev);
                            // props.setDevice("mobile");
                            preDev="mobile";
                        }
                    }  
                    if( widthOfCanvas >= parseInt(props?.formdata?.style?.Breakpoint?.Tab?.StartValue)
                    && widthOfCanvas < parseInt(props?.formdata?.style?.Breakpoint?.Tab?.EndValue))
                    {
                        props.formdata.style["WidthOfTablet"]=widthOfCanvas;
                        if(preDev!=="tablet")
                        {
                            changeCanvasLayout(2,"tablet",preDev);
                            // props.setDevice("tablet");
                            preDev="tablet";
                        }
                    }  
                    if(widthOfCanvas >=  parseInt(props?.formdata?.style?.Breakpoint?.Desktop?.StartValue)
                    && widthOfCanvas <  parseInt(props?.formdata?.style?.Breakpoint?.Desktop?.EndValue))
                    {
                        props.formdata.style["WidthOfWeb"]=widthOfCanvas;
    
                        if(preDev!=="web")
                        {   
                            changeCanvasLayout(3,"web",preDev);
                            // props.setDevice("web");
                            preDev="web";
                        }
                    }
    
                    if(props.formdata.style && props.formdata.style["Breakpoint"])
                    {
                        Object.keys(props.formdata.style["Breakpoint"]).forEach((DeviceName,index)=>{
                            if(DeviceName.includes("Custom")) {
                                var startPoint=parseInt(props.formdata.style["Breakpoint"][DeviceName]["StartValue"]);
                                var endPoint=parseInt(props.formdata.style["Breakpoint"][DeviceName]["EndValue"]);
                
                                if(widthOfCanvas >= startPoint && widthOfCanvas <= endPoint) {
                                    // props.setCustomColumnLayout(12);
                                    changeCanvasLayout(props.customColumnLayout, "Custom", "Custom");
                                }
                            }
                        })
                    }   
    
                    // if(props?.formdata?.style?.CurrentDevice?.WidthOfCanvas >= parseInt(props?.formdata?.style?.Breakpoint?.Mobile?.StartValue) 
                    // && props?.formdata?.style?.CurrentDevice?.WidthOfCanvas < parseInt(props?.formdata?.style?.Breakpoint?.Mobile?.EndValue))
                    // {
                    //     props.formdata.style["WidthOfMobile"] = props.formdata.style["WidthOfCanvas"];
                    //     if(currentDeviceCanvas!=="mobile")
                    //     {
                    //         changeCanvasLayout(1,"mobile",currentDeviceCanvas);
                    //         props.setDevice("mobile");
                    //         currentDeviceCanvas="mobile";
                    //     }
                    // } else if( props?.formdata?.style?.CurrentDevice?.WidthOfCanvas >= parseInt(props?.formdata?.style?.Breakpoint?.Tab?.StartValue)
                    // && props?.formdata?.style?.CurrentDevice?.WidthOfCanvas < parseInt(props?.formdata?.style?.Breakpoint?.Tab?.EndValue))
                    // {
                    //     props.formdata.style["WidthOfTablet"]=props.formdata.style["WidthOfCanvas"];
                    //     if(currentDeviceCanvas!=="tablet")
                    //     {
                    //         changeCanvasLayout(2,"tablet",currentDeviceCanvas);
                    //         props.setDevice("tablet");
                    //         currentDeviceCanvas="tablet";
                    //     }
                    // } else if(props?.formdata?.style?.CurrentDevice?.WidthOfCanvas >=  parseInt(props?.formdata?.style?.Breakpoint?.Desktop?.StartValue)
                    // && props?.formdata?.style?.CurrentDevice?.WidthOfCanvas <  parseInt(props?.formdata?.style?.Breakpoint?.Desktop?.EndValue))
                    // {
                    //     props.formdata.style["WidthOfWeb"]=props.formdata.style["WidthOfCanvas"];
                    //     if(currentDeviceCanvas!=="web")
                    //     {
                    //         changeCanvasLayout(3,"web",currentDeviceCanvas);
                    //         props.setDevice("web");
                    //         currentDeviceCanvas="web";
                    //     } else {
                    //         updatedComponentInFormState();
                    //     }
                    // }
    
                         
                }

            }
        }
    }

    function handleEscapeKey(e){
        if(e.code === "Escape"){
            if(openCanvasForSubform === "subform"){
                handleSubForm("Cancel")
            }
            if(openCanvasForSubform === "advanceListviewFromScratch"){
                handleSubForm("Save listviewOverlay")
            }
        } 
    }

    var startMobile;
    var endMobile;
    var startTab;
    var endTab;
    var startDesktop;
    var endDesktop;
   
    var startCustom;
    var endCustom;

    var displayWidth;
    var canWidth;

        if(props?.formdata?.style){
            startMobile = parseInt(props.formdata.style?.["Breakpoint"]?.["Mobile"]?.["StartValue"]);
            endMobile = parseInt(props.formdata.style?.["Breakpoint"]?.["Mobile"]?.["EndValue"]);
            startTab = parseInt(props.formdata.style?.["Breakpoint"]?.["Tab"]?.["StartValue"]);
            endTab = parseInt(props.formdata.style?.["Breakpoint"]?.["Tab"]?.["EndValue"]);
            startDesktop = parseInt(props.formdata.style?.["Breakpoint"]?.["Desktop"]?.["StartValue"]);
            endDesktop = parseInt(props.formdata.style?.["Breakpoint"]?.["Desktop"]?.["EndValue"]);
            startCustom=parseInt(props.formdata.style?.["Breakpoint"]?.["Custom"]?.["StartValue"]);
            endCustom=parseInt(props.formdata.style?.["Breakpoint"]?.["Custom"]?.["EndValue"]);
        }

         if(formState2?.style){
            startMobile = parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["StartValue"]);
            endMobile = parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["EndValue"]);
            startTab = parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["StartValue"]);
            endTab = parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["EndValue"]);
            startDesktop = parseInt(formState2.style?.["Breakpoint"]?.["Desktop"]?.["StartValue"]);
            endDesktop = parseInt(formState2.style?.["Breakpoint"]?.["Desktop"]?.["EndValue"]);
            startCustom=parseInt(formState2.style?.["Breakpoint"]?.["Custom"]?.["StartValue"]);
            endCustom=parseInt(formState2.style?.["Breakpoint"]?.["Custom"]?.["EndValue"]);
        }
    
    function handleLayoutforPreview(form_buffer , renderPlease) {
        // handleScreenResize();

      let returned_FrameLayoutJson = {};
      if(!externalIformUrl.includes("afb_subform")) {
        const displayElement = document.getElementById("psh_root_not_mf");
        const displayWidthfromRef=shadeRef?.current?.clientWidth;

        const formBufferr = form_buffer || formState2 || props?.formdata ;
        
        if(displayElement!==null || displayWidthfromRef) {
            // displayWidth = displayElement?.getBoundingClientRect()?.width;  
            displayWidth = shadeRef?.current?.clientWidth || displayElement?.offsetWidth-14;
            if(previewMode) {

                if(displayWidth <= endMobile ){
                  if(formBufferr?.currentDeviceOnApp?.toLowerCase() !== "mobile" || updatedOnce===false || renderPlease){
                    if(currentDeviceCanvas!=="mobile" || renderPlease)
                    {
                        if(form_buffer){
                          returned_FrameLayoutJson = changeCanvasLayout(1,"mobile",currentDeviceCanvas,form_buffer);
                        }else{
                          changeCanvasLayout(1,"mobile",currentDeviceCanvas);
                        }
                        if(openCanvasForPreview === "showDataAdditonSection"){
                          currentDeviceCanvas="mobile";
                          changeCanvasLayoutforlistview(subFormListviewJson , 1,"mobile",undefined)
                        }
                        else if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview"){
                          currentDeviceCanvas="mobile";
                          changeCanvasLayoutforlistview(currentAdvanceListviewStateJson , 1,"mobile",undefined)
                        }
                        setOnceUpdated(true);
                        currentDeviceCanvas="mobile";
                        // props?.setDevice("mobile");
                        if(props.setDevice){
                            // props?.setDevice("mobile");
                        }
                    }
                  }
                } 
                if(displayWidth <= endTab && displayWidth >= startTab){
                  if(formBufferr?.currentDeviceOnApp?.toLowerCase() !== "tablet" || updatedOnce===false || renderPlease){
                    if(currentDeviceCanvas!=="tablet" || renderPlease)
                    {
                      if(form_buffer){
                        returned_FrameLayoutJson = changeCanvasLayout(2,"tablet",currentDeviceCanvas,form_buffer);
                      }
                      else{
                        changeCanvasLayout(2,"tablet",currentDeviceCanvas);
                      }

                        if(openCanvasForPreview === "showDataAdditonSection"){
                          changeCanvasLayoutforlistview(subFormListviewJson , 2,"tablet",undefined)
                        }
                        else if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview"){
                          currentDeviceCanvas="tablet";
                          changeCanvasLayoutforlistview(currentAdvanceListviewStateJson , 1,"tablet",undefined)
                        }
                        setOnceUpdated(true);

                        currentDeviceCanvas="tablet";
                        // props?.setDevice("tablet");
                        if(props.setDevice){
                            // props?.setDevice("tablet");
                        }
                    }
                  }
                }  
                if( displayWidth >= startDesktop && !startCustom && !endCustom){
                  if(formBufferr?.currentDeviceOnApp?.toLowerCase() !== "web" || updatedOnce===false || renderPlease){
                      if(form_buffer){
                        returned_FrameLayoutJson = changeCanvasLayout(3,"web",currentDeviceCanvas,form_buffer);
                      }
                      else{
                        changeCanvasLayout(3,"web",currentDeviceCanvas);
                      }
                  

                    if(openCanvasForPreview === "showDataAdditonSection"){
                      changeCanvasLayoutforlistview(subFormListviewJson , 3,"web",undefined);
                    }
                    else if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview"){
                      currentDeviceCanvas="web";
                      changeCanvasLayoutforlistview(currentAdvanceListviewStateJson , 1,"web",undefined);
                    }

                        setOnceUpdated(true);

                    currentDeviceCanvas="web";
                    // props?.setDevice("web");
                    if(props.setDevice){
                        // props?.setDevice("web");
                    }
                  }
                } 
                if(startCustom && endCustom){
                    if(displayWidth <= endCustom && displayWidth >= startCustom){
                        changeCanvasLayout(props.customColumnLayout, "Custom", "Custom");
                        setOnceUpdated(true);
                        
                    } 
                }
              }      
            }
        } else {
          if(window.updateJsonOnLoad) {
            window.updateJsonOnLoad();
        }      
		  }
      return returned_FrameLayoutJson;
      
    }


    // useEffect(()=>{
    //     if(false){
    //         let element;
    //         let resizeObserver;
    //         if(document.getElementById("canvasId")){
               
    //                 element =document.getElementById("canvasId");
    
    //             if (!window.ResizeObserver) install();
    
    //             resizeObserver=new ResizeObserver((()=>{
                   
    //                 if(element){
    //                     const  elementWidthTemp = element.getBoundingClientRect().width;
    //                     setTempCanWidth(elementWidthTemp)
    //                 }
    //             }));
    //            resizeObserver.observe(element)
    //            return () => {
    //             if(element){
    //                 resizeObserver && resizeObserver.unobserve(element)
    //             }
    //            }
    //         }
    //     }
    // },[])

    const resizeObserverRef = useRef(null);
    const resizeObserverRef2 = useRef(null);
    const canvas_Height = useRef();

    useLayoutEffect(() => {
        // Initialize ResizeObserver and attach it to the div element
        resizeObserverRef.current = new ResizeObserver((entries) => {
        for (const entry of entries) {
            const { width, height, top, bottom } = entry.contentRect;
            console.log('Width:', width);
            // canvas_Height.current = height + 'px';
            // if(props?.previewmode)
            // setTempCanWidth(width)
            // setTempCanHeight(height)
            dispatch(updateStateInRedux({name: "tempCanWidth", key: containerId, value: width}));
            dispatch(updateStateInRedux({name: "tempCanHeight", key: containerId, value: height}));
            console.log('Height:', height);
            console.log('Top:', top);
            console.log('Bottom:', bottom);
        }
        });

        // Start observing the div element
        if(!props?.previewmode){
            if (imageRef2.current) {
            resizeObserverRef.current.observe(imageRef2.current);
            }
        }
        if(props?.previewmode){
            if (imageRef.current) {
                resizeObserverRef.current.observe(imageRef.current);
                }
        }

        // Cleanup function
        return () => {
        if (resizeObserverRef.current && imageRef2.current) {
            resizeObserverRef.current.unobserve(imageRef2.current);
        }
        if (resizeObserverRef.current && imageRef.current) {
            resizeObserverRef.current.unobserve(imageRef.current);
        }
        };
    }, []);
    useLayoutEffect(() => {
        // Initialize ResizeObserver and attach it to the div element
        resizeObserverRef2.current = new ResizeObserver((entries) => {
        for (const entry of entries) {
            const { width, height, top, bottom } = entry.contentRect;
            console.log('WidthDesignPage:', width);
            // canvas_Height.current = height + 'px';
            // if(props?.previewmode)
            dispatch(updateStateInRedux({name: "tempCanWidthDesignPage", key: containerId, value: width}));
            dispatch(updateStateInRedux({name: "tempCanHeightDesignPage", key: containerId, value: height}));
            console.log('HeightDesignPage:', height);
            console.log('TopDesignPage:', top);
            console.log('BottomDesignPage:', bottom);
        }
        });

        // Start observing the div element
        if(props?.previewmode){
            if (imageRef4.current) {
                resizeObserverRef2.current.observe(imageRef4.current);
                }
        }

        // Cleanup function
        return () => {
        if (resizeObserverRef2.current && imageRef4.current) {
            resizeObserverRef2.current.unobserve(imageRef4.current);
        }
        };
    }, []);

    function checkWidthOnResizeOfWindow(){
        var widthOfPreviewColumn;
        if(columnElement!==null){
         widthOfPreviewColumn = tempCanWidthDesignPage;
        }
        widthOfPreviewColumn=widthOfPreviewColumn+50;

    
        if(formState2 && formState2.style && formState2.style?.["Breakpoint"] && ((widthOfPreviewColumn >= (formState2 && formState2.style?.["Breakpoint"]?.["Mobile"] && parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["StartValue"]) ) )
        && (widthOfPreviewColumn < (formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Mobile"] && parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["EndValue"])))))
            {
              setDevicePreview("mobile");
            }     
        else if(formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Tab"] && ((widthOfPreviewColumn >= (formState2.style?.["Breakpoint"]?.["Tab"] && parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["StartValue"])) )
          && (widthOfPreviewColumn < ( formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Tab"] && parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["EndValue"])))))
        {
            setDevicePreview("tab");
        }
        else if(formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Desktop"] && ((widthOfPreviewColumn >= (formState2.style?.["Breakpoint"]?.["Desktop"] && parseInt(formState2.style?.["Breakpoint"]?.["Desktop"]?.["StartValue"])) )
          && (widthOfPreviewColumn < (formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Desktop"] && formState2.style?.["Breakpoint"]?.["Desktop"] && parseInt(formState2.style?.["Breakpoint"]?.["Desktop"]?.["EndValue"]))))){
            setDevicePreview("web");
          }
          else{
            setDevicePreview("web");
        }
    
    //    setWindowWidth(window.innerWidth);
    
    };

     useEffect(()=>{
            checkWidthOnResizeOfWindow();
            
            const elementForWidth= document.getElementById("design_page") || document.getElementById("canvasId");
                window.addEventListener("resize",checkWidthOnResizeOfWindow);
                elementForWidth?.addEventListener("resize",checkWidthOnResizeOfWindow);
             return () => { 
                window.removeEventListener("resize", checkWidthOnResizeOfWindow);
                elementForWidth?.removeEventListener("resize", checkWidthOnResizeOfWindow);
            };
        
     },[])

     useEffect(()=>{
        if(formMataData) {
            checkWidthOnResizeOfWindow();
        }
     },[tempCanWidth]);
    
    useEffect(()=>{
        
           if(previewMode){
            handleLayoutforPreview()
           }
            
    },[tempCanWidth,activePage?.id, activePage, activePage?.formId, formState2])

    var columnElement=document.getElementById("design_page") 

    // function correctMDValueonLoad(){
    //     var widthOfPreviewColumn;
    //     if(columnElement!==null){
    //      widthOfPreviewColumn=columnElement.getBoundingClientRect().width;
    //     }
    //     widthOfPreviewColumn=widthOfPreviewColumn+50;

    
    //     if(formState2 && formState2.style && formState2.style?.["Breakpoint"] && ((widthOfPreviewColumn >= (formState2 && formState2.style?.["Breakpoint"]?.["Mobile"] && parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["StartValue"]) ) )
    //     && (widthOfPreviewColumn < (formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Mobile"] && parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["EndValue"])))))
    //         {
    //         changeCanvasLayout(12,"mobile", "none");
              
    //         }     
    //     else if(formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Tab"] && ((widthOfPreviewColumn >= (formState2.style?.["Breakpoint"]?.["Tab"] && parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["StartValue"])) )
    //       && (widthOfPreviewColumn < ( formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Tab"] && parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["EndValue"])))))
    //     {
    //         changeCanvasLayout(6,"tab", "none");

    //     }
    //     else if(formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Desktop"] && ((widthOfPreviewColumn >= (formState2.style?.["Breakpoint"]?.["Desktop"] && parseInt(formState2.style?.["Breakpoint"]?.["Desktop"]?.["StartValue"])) )
    //       && (widthOfPreviewColumn < (formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Desktop"] && formState2.style?.["Breakpoint"]?.["Desktop"] && parseInt(formState2.style?.["Breakpoint"]?.["Desktop"]?.["EndValue"]))))){
    //         changeCanvasLayout(4,"web", "none");

    //       }
    //       else{
    //         changeCanvasLayout(4,"web", "none");

    //     }
    // }

    // useEffect(()=>{
    //     correctMDValueonLoad();
    // },[]);

    // window.onresize = handleLayoutforPreview;
    
    // window.addEventListener('resize', handleLayoutforPreview)  
    
    useEffect(()=>{    
        const formdata =  props?.formdata;
            
        if(checkEmpty(formdata) && !openCanvasForSubform && !isButtonSubformOpen){
            setAddContainer(false)
            setGeneratePage(false)
        }
        else{
           setAddContainer(true)           
        }
        
        },[props?.formdata]) 

    useEffect(()=>{    
        const formdata = props?.formdata;
        if(!openMarvinModal && checkEmpty(formdata)) {
          setGeneratePage(false);
          setAddContainer(false);
        }
    }, [openMarvinModal]);

    const [showPageTemplate, setShowPageTemplate]=useState({open : false, selectedTemplate : 'None'});
    function handleTemplate(arg) {
        if(arg ==="open"){
            setShowPageTemplate((prev)=>{return{...prev, open:true}})
        }
    }

    const emptyPageDiv=<div style={{ position: "absolute",top: "40%", left: "50%",transform: "translate(-50%, 0)",zIndex:"1" }}>
        {t("Drag_Drop_Message")} &nbsp;
        <span style={{color:"#0072C6",borderBottom:"1px solid #0072C6",cursor:"pointer"}} onClick={(ev)=> handleTemplate('open')} > 
            {t("Page Templates")} 
        </span> 
    </div>

    var resizeCanvasStyle={ 
        // right:  t("styles:sizeHandlerLeft"),
        // left : t("styles:sizeHandlerRight"),
        right:t("styles:sizeHandlerRight"),
        left:t("styles:sizeHandlerLeft")
        
    };

    
    //const canvas_bodyHeight = useRef(0);

    useEffect(()=>{
            const height=document.querySelector("#canvasId")?.getBoundingClientRect()?.top;
            canvas_Height.current = height;
            setCanvasTop(height);
        // const canvasbodyHeight=document.querySelector("#design_page")?.getBoundingClientRect()?.top
        // canvas_bodyHeight.current = canvasbodyHeight;
    },[document.querySelector("#canvasId")?.getBoundingClientRect()?.top]);

    const isTouchDevice = () => {
        let ispshOpenedInMobileApp = false;
        const details = navigator.userAgent;
        const regexp = /android|iphone|kindle|ipad/i;
        const isMobileDevice = regexp.test(details);
        
        if (isMobileDevice) {
          ispshOpenedInMobileApp = true;
        } else {
          ispshOpenedInMobileApp = false;
        };

        return ispshOpenedInMobileApp;
    }

    useEffect(() => {
        const canvasEl = document.querySelector("#canvasId");
        
        if((canvasEl) && !props?.previewmode) {
            const resizeDiv = document.querySelector("#resizeCanvasDrag");
            const isTouchDeviceCheck = isTouchDevice();

            const currentWidth = tempCanWidth;

            if (currentWidth < 20 || isTouchDeviceCheck) {
                if(resizeDiv) resizeDiv.style.display = "none";
                canvasEl.style.border = "none";
            } else {
                if(resizeDiv) resizeDiv.style.display = "block";
                canvasEl.style.border = "1px solid rgba(0,0,0,.125)";
            } 
        } else if(canvasEl && props?.previewmode) {
          canvasEl.style.border = "0";
        }
    
      }, [props?.formdata?.style?.["Breakpoint"]]);

    let inlineCanvasStyleJson = {
        minHeight: '400px !important',
    };
    let inlineCanvasStyleJson2 = {
      ...canvas_bodyStyle,
      minHeight: '400px !important',
    };


    function handleCol(id){
        const selectTag = document.getElementById(id);
        const colVal = selectTag.options[selectTag.selectedIndex].value;
        currentListviewForSubform.listviewFrameLayoutJson.children[0].children[0].ColumnLayout = colVal;
        changeSectionLayout(colVal, currentListviewForSubform?.listviewFrameLayoutJson?.children[0].children[0], "listview");
    }

    // const [wizardPresent,setWizardPresent]=useState(false);

    // useEffect(()=>{
    //     if( ( document.querySelector(".wizardMain_Id") || (document.querySelector("[control_id=wizard]") && !document.querySelector("[elem_type=Menu]"))) && wizardPresent===false  ) {
    //         setWizardPresent(true);
    //     }
    //     else if(!document.querySelector(".wizardMain_Id") && !document.querySelector("[control_id=wizard]")  && wizardPresent===true){
    //         setWizardPresent(false);
    //     } 
    //     else if(!document.querySelector(".wizardMain_Id") && document.querySelector("[elem_type=Menu]") && wizardPresent===true) {
    //         setWizardPresent(false);
    //     }
    // })

    useEffect(() => {
        if(document.getElementsByClassName("propertiesBody").length > 0 && imageRef3.current) {
            const mainCanvasHeight = document.querySelector("#mainCanvas")?.getBoundingClientRect().height;
            document.getElementsByClassName("propertiesBody")[0].style.maxHeight = `${mainCanvasHeight}px`;
            document.getElementsByClassName("propertiesBody")[0].style.minHeight = `${mainCanvasHeight}px`;
            document.getElementsByClassName("propertiesBody")[0].style.height = `${mainCanvasHeight}px`;
        }
    },[imageRef3.current]);

      function getAllPages(forComponent){
        let payload = { withCredentials: true };
        axios.get(`/interfaces/${activeApplication.applicationId}`,)
            .then((res)=>{
                setAllPages([...(res.data)]);
            })
            .catch(()=>{
                 console.log("ERROR ON LOADING PAGES OF APP ID ", activeApplication.applicationId );
            })
    }

    function isIphone() {
      return /iPhone/.test(navigator.userAgent) && !window.MSStream;
    }

    const resetCSSForPortal = {
        margin: 0,
        padding: 0,
        height: "var(--app-height-form)",
        overflow: "unset",
    }

    let pagepPropertyRef = useRef({})
    
    useLayoutEffect(()=>{
        // generatePageStyle()
    },[cloneDeep(formState2?.style)])


    if(previewMode){
        return (
            <>
            <div className="child_mf_not" style={{
              opacity: 0,
              position: "absolute",
              top: -91873819391,
              left: -172367263,
              zIndex: -10000,
              pointerEvents: "none"
            }}
            tabIndex={"-1"}
            >
              <input
                type="text"
                placeholder="username"
                autoComplete="off"
                name='username'
                tabIndex={"-1"}
                style={{
                  pointerEvents: "none"
                }}
              />

              <input
                type="password"
                placeholder="password"
                autoComplete="off"
                name='password'
                tabIndex={"-1"}
                style={{
                  pointerEvents: "none"
                }}
              />
            </div>
            <Card
                // id='design_page' 
                id="canvasId"
                ref={imageRef}
                className={ (isPortal && getGdToken()) || formMataData ?  device === undefined ? `${styles.canvas_css_Device2} canvas` : `${styles.canvas_css2} canvas` : device === undefined ? `${styles.canvas_css_Device} canvas` : `${styles.canvas_css} canvas`} 
                // style={inlineCanvasStyleJson}
                style={device==="mobile"? {mobileView,
                    height: `100%`,
                    overflow:formState2?.containerControl === "wizard_h"? 'hidden' : 'auto',
                    overflowY: formState2?.containerControl === "wizard_h"? fixedFooter === 'false' || fixedFooter === false ? 'auto' : 'hidden' : ( openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "showDataAdditonSection" ) || formState2?.containerControl === "sidenavigation"  || formState2?.containerControl === "wizard_v"  ? 'hidden' : 'auto',
                    ...(isPortal ? resetCSSForPortal : {} ),
                    minHeight: '400px !important',...formState2?.finalStyles,
                    backgroundColor: (openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform")
                    ? "none" : (formState2?.finalStyles?.backgroundColor || formState2?.theme?.PageStyle?.backgroundColor ||  "#FFFFFF"),
                    backgroundRepeat: "no-repeat",
                    backgroundImage: openCanvasForSubform === "subform" ? "" : updatedImage ? updatedImage : "none",
                } : 
                device==="tablet"? {tabletView, 
                    height: `100%`,
                    minHeight: '400px !important',...formState2?.finalStyles,
                    backgroundColor: (openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform")
                    ? "none" : (formState2?.finalStyles?.backgroundColor || formState2?.theme?.PageStyle?.backgroundColor ||  "#FFFFFF"),
                    ...(isPortal ? resetCSSForPortal : {} ),
                    backgroundRepeat: "no-repeat",
                    backgroundImage: openCanvasForSubform === "subform" ? "" : updatedImage ? updatedImage : "none",
                } : {webView, 
                    height: `100%`, 
                    minHeight: '400px !important',
                    overflow:'auto',...formState2?.finalStyles,
                    backgroundColor: (openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform")
                    ? "none" : (formState2?.finalStyles?.backgroundColor || formState2?.theme?.PageStyle?.backgroundColor ||  "#FFFFFF"),
                    ...(isPortal ? resetCSSForPortal : {} ),
                    // scrollbarWidth:'none',
                    backgroundRepeat: "no-repeat",
                    backgroundImage: openCanvasForSubform === "subform" ? "" : updatedImage ? updatedImage : "none",
                }}
                elem_type='Design Page' 
                control_id='design_page' 
                deviceMode={device}
            >
                <PrepareCSSClass 
                    stylingData={{
                        'spacingThemeControls' : jsonForSpacingDiv, 
                        'spacingThemeLabel' : jsonForSpacingLabel,
                        'controlFontSize' : jsonForControlFontSize
                    }}   
                /> 
                <div 
                ref={shadeRef} > </div>
                <div id='fullScreenSurvey' style={{display: fullScreenMode ? 'block':'none'}}>
                </div>

                { formdata && formdata?.pageStyle && preparecss === false ?
                    <CSSPreparation stylingData={formdata?.pageStyle} setStylingData={(stylingData)=> setStylingData(stylingData)}/> 
                : null }
                <Card.Body
                    className={
                        openCanvasForSubform === "subform" || openCanvasForSubform === "advanceListviewFromScratch" ? 
                            [styles.subformCanvas_body, "scrollable"].join(" ") : 
                            [styles.canvas_body, "scrollable"].join(" ")
                    }
                    id='design_page' 
                    elem_type='Design Page' 
                    control_id='design_page'
                    ref={imageRef4}
                    style={{...inlineCanvasStyleJson2,...formdata?.pageStyle, 
                    overflowY: formState2?.containerControl === "wizard_h" || formState2?.containerControl === "wizard_v" ?  'auto' : ( openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "showDataAdditonSection" ) || formState2?.containerControl === "sidenavigation" ? 'hidden' : 'auto',
                    overflowX:formState2?.containerControl === "wizard_h" || formState2?.containerControl === "wizard_v" || formState2?.containerControl === "sidenavigation" ? 'hidden' : 'auto',
                    backgroundColor: formState2?.finalStyles?.backgroundImage || formState2?.finalStyles?.backgroundColor || formState2?.theme?.PageStyle?.backgroundColor ? 'transparent' : '#FFFFFF',
                    // backgroundImage: formState2?.finalStyles?.backgroundImage || "",
                    backgroundImage: openCanvasForSubform === "subform" ? "" : updatedImage ? updatedImage : "none",
                    backgroundPositionX: formState2?.finalStyles?.backgroundPositionX,
                    backgroundPositionY :formState2?.finalStyles?.backgroundPositionY,
                    backgroundSize: formState2?.finalStyles?.backgroundSize,
                    backgroundRepeat:"no-repeat",
                    border: previewMode ? '0px': '',
                    display: openCanvasForSubform === "subform" ? "inline-table" : "block",
                    // height : "fit-content"
                }}
                    
                >
                  
                  <div id="canvas_id_screenshot" 
                    style={{
                    overflow: formState2.containerControl === "sidenavigation" || formState2.containerControl === "wizard_v" || (formState2.containerControl === "wizard_h" && (fixedFooter === true || fixedFooter === 'true')) ? "hidden" : "auto",
                    ...(openCanvasForSubform === "subform" ?
                    {overflowY: "auto", height: `calc( ${tempCanHeight}px - 116px )`}
                     : ( openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "showDataAdditonSection" )  ? 
                      {overflowY: "auto", height: "calc(100% - 90px)"} : callTakeScreenshot ?
                      { height:"fit-content", minHeight : "fit-content" } : {height: '100%'})
                    }}
                  >
                    {
                        ((props.openCanvasForSubform!=='subform' && props.openCanvasForSubform!=='advanceListviewFromScratch' && props.openCanvasForSubform!=='showDataAdditonSection' && !window.location.pathname.includes("afb_subform") && showLoginHeader.current && (applicationNameObj?.formName !== homePage && activePage?.formId != applicationDataVar?.defaultFormId) && activePage?.formId) || props?.isSSO )?
                        <LoginHeader data={
                              props.headerJSON
                            } 
                            activePageFormId={activePage?.formId}
                            activePage={activePage}
                            containerId={containerId}
                            defaultFormId={applicationDataVar?.defaultFormId}
                            previewmode={previewMode} loggedIn={loggedIn} 
                            showLoginHeader={showLoginHeader.current} isSSO={props?.isSSO} themeData={formState2?.theme}/>
                            :<></>
                    }
                    <div style={{
                      height:(formState2?.containerControl === "wizard_h" || formState2?.containerControl === "wizard_v" || formState2?.containerControl === "sidenavigation") && (fixedFooter === false || fixedFooter === 'false') ? '100%': `100%`, 
                      overflow:formState2?.containerControl === "wizard_h" || formState2?.containerControl === "wizard_v" || formState2?.containerControl === "sidenavigation" ? '' : (props.openCanvasForSubform==='subform' || props.openCanvasForSubform==='advanceListviewFromScratch' || props.openCanvasForSubform==='showDataAdditonSection') ? "auto" : "",
                      justifyContent: globalLoading ? "center" : "",
                      alignItems:globalLoading ? "center" : "",
                      display: globalLoading ? "flex" : "block",
                      width: globalLoading ? "100%" : "inherit",
                      flexDirection:globalLoading ?"column" : "",
                      // height : "fit-content"
                      }}
                    >
                    <Loading/>

                    {globalLoading ? <><CircularProgress size={30}/> <h6 style={{color:`var(--brand_color2)`}}>{t(globalLoadingMessage)}</h6></> : props.renderChild}


                    </div>    
                  </div>
                </Card.Body>
            </Card>                
            </>
        );
    } 
    else {
        return (
          <>
            <div className="child_mf_not" style={{
              opacity: 0,
              position: "absolute",
              top: -91873819391,
              left: -172367263,
              zIndex: -10000,
              pointerEvents: "none"
            }}
            tabIndex={"-1"}
            >
              <input
                type="text"
                placeholder="username"
                autoComplete="off"
                name='username'
                tabIndex={"-1"}
                style={{
                  pointerEvents: "none"
                }}
              />

              <input
                type="password"
                placeholder="password"
                autoComplete="off"
                name='password'
                tabIndex={"-1"}
                style={{
                  pointerEvents: "none"
                }}
              />
            </div>
            <Card
              className={[`${styles.canvas_css} canvas`, "form_area", styles.canvas_css_mt].join(" ")}
              style={
                device === "mobile"
                  ? {
                      mobileView,
                      height: `calc( calc( var(--app-height-form) * 0.98) - ${
                        containerId !== "mf_forms_customise" && window.location.href.indexOf("pmWebDesigner") > -1
                          ? canvas_Height.current + 10
                          : containerId === "mf_forms_int_des"
                          ? canvas_Height.current + 24
                          : canvas_Height.current
                      }px - (${isMobile ? "60px" : "0px"}))`,
                      overflow: "auto",
                      minHeight: "400px !important",
                      backgroundColor:(openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform")
                      ? "none" : (formState2?.finalStyles?.backgroundColor || formState2?.theme?.PageStyle?.backgroundColor || "#FFFFFF")
                    }
                  : device === "tablet"
                  ? {
                      tabletView,
                      height: `calc( calc( var(--app-height-form) * 0.98) - ${
                        containerId !== "mf_forms_customise" && window.location.href.indexOf("pmWebDesigner") > -1
                          ? canvas_Height.current + 10
                          : containerId === "mf_forms_int_des"
                          ? canvas_Height.current + 24
                          : canvas_Height.current
                      }px - (${isMobile ? "60px" : "0px"}))`,
                      minHeight: "400px !important",
                      backgroundColor: (openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform")
                      ? "none" : (formState2?.finalStyles?.backgroundColor ||
                        formState2?.theme?.PageStyle?.backgroundColor ||
                        "#FFFFFF")
                    }
                  : {
                      webView,
                      height: `calc( calc( var(--app-height-form) * 0.98) - ${
                        containerId !== "mf_forms_customise" && window.location.href.indexOf("pmWebDesigner") > -1
                          ? canvas_Height.current + 10
                          : containerId === "mf_forms_int_des"
                          ? canvas_Height.current + 24
                          : canvas_Height.current
                      }px - (${isMobile ? "60px" : "0px"}))`,
                      minHeight: "400px !important",
                      overflow: "auto",
                      // scrollbarWidth: "none",
                      backgroundColor: (openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform")
                      ? "#FFFFFF" : (formState2?.finalStyles?.backgroundColor || formState2?.theme?.PageStyle?.backgroundColor || "#FFFFFF")
                    }
              }
              onClick={() => {
                setSelected({ id: "", tempStatus: "" });
              }}
              elem_type="Design Page"
              control_id="design_page"
              id="canvasId"
              ref={imageRef2}
              deviceMode={device}
            >
              <PrepareCSSClass
                stylingData={{
                  spacingThemeControls: jsonForSpacingDiv,
                  spacingThemeLabel: jsonForSpacingLabel,
                  controlFontSize: jsonForControlFontSize
                }}
              />

              {/* {checkEmpty() &&
              ((showLoginHeader?.current && activePage?.formId === applicationDataVar?.defaultFormId) ||
                !showLoginHeader?.current) ? (
                <div role="region" aria-label="Empty Screen Text Region">
                  {emptyPageDiv}

                  <SelectTemplate
                    isTemplate={true}
                    open={showPageTemplate.open}
                    key={showPageTemplate.open}
                    handleTemplate={(arg) => handleTemplate(arg)}
                    handleClose={handleClose}
                    setSelectedTemplateName={setSelectedTemplateName}
                    getAllPages={() => getAllPages("page")}
                    componentFor={"page"}
                    pageProperties={pageProperties}
                  />
                </div>
              ) : null} */}

              {isMobile ? null : (
                <div id="resizeCanvasDrag" style={resizeCanvasStyle} className={styles.resizeCanvas}>
                  <img
                    className={styles.defaultImageHandler}
                    src={require("../../../Icons/HandlerBreakpoint.svg").default}
                    style={{ transform: translationStyles1 ? "rotate(180deg)" : "initial" }}
                    alt="HandlerBreakpoint Icon"
                  />
                </div>
              )}

              <div ref={shadeRef}></div>

              {formdata && formdata?.pageStyle && preparecss === false ? (
                <CSSPreparation
                  stylingData={formdata?.pageStyle}
                  setStylingData={(stylingData) => setStylingData(stylingData)}
                />
              ) : null}
              <Loading/>

                <Card.Body
                  tabIndex="0"
                  onKeyDown={(e) => handleEscapeKey(e)}
                  className={
                    openCanvasForSubform === "subform" || openCanvasForSubform === "advanceListviewFromScratch"
                      ? [
                          styles.subformCanvas_body,
                          ...(openCanvasForSubform === "subform" ? [styles.subformCanvas_subformBody] : []),
                          ,
                          openCanvasForSubform === "advanceListviewFromScratch" ? css(overlaySyleSheet1.styling) : null,
                          "scrollable"
                        ].join(" ")
                      : [styles.canvas_body, "scrollable"].join(" ")
                  }
                  elem_type="Design Page"
                  control_id="design_page"
                  // style={canvas_bodyStyle}
                  style={{
                    ...canvas_bodyStyle,
                    ...formdata?.pageStyle,
                    // height: `calc(99vh - ${canvas_bodyHeight.current}px)` ,
                    overflowY:
                      formState2?.containerControl === "wizard_h" ||
                      formState2?.containerControl === "wizard_v" ||
                      formState2?.containerControl === "sidenavigation" 
                        ? "auto"
                        : ( openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "showDataAdditonSection" ) ?
                        "hidden" :
                        "auto",
                    minHeight: "400px !important",
                    scrollbarWidth: "thin",
                    backgroundColor: `${
                      openCanvasForSubform === "subform"
                        ? props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["SubformBackgroundColor"]
                          ? props?.subFormJson?.pageStyle["SubformBackgroundColor"]
                          : "#ffffff"
                        : "transparent"
                    }`,

                    backgroundImage: (openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform") ? "none" : updatedImage ? updatedImage : "none",
                    // backgroundColor:formState2?.finalStyles.backgroundColor || "transparent",
                    // backgroundImage: formState2?.finalStyles.backgroundImage || "",
                    backgroundPositionX: formState2?.finalStyles?.backgroundPositionX,
                    backgroundPositionY: formState2?.finalStyles?.backgroundPositionY,
                    backgroundSize: formState2?.finalStyles?.backgroundSize,
                    backgroundRepeat: "no-repeat",
                    // backgroundColor:`${props?.subFormJson?.pageStyle["BackgroundColor"]}`
                    // width:"unset"
                    border: previewMode ? "0px" : "",
                    display: openCanvasForSubform === "subform" ? "inline-table" : "block"

                  }}
                  // id="canvasbody_id"
                  id="design_page"
                  // id="canvasId"
                  // onDrop={(event)=>drop(event)}
                  onDrop={(ev) => {ev.addContainer=addContainer
                    ev.generatePage=generatePage
                     props.handleReorderDrop(ev, "Design Page")}}
                  onDragOver={(event) => targetForDrop(event,addContainer,generatePage)}
                  onDragLeave={(event)=>props.handleDragLeave(event,addContainer,generatePage)}
                  onClick={(event) => {
                    if(openCanvasForSubform === "subform") 
                      dispatch(updateStateInRedux({name: "isButtonProperties", key: containerId, value: true}));
                    props.testClick(event);
                   }}
                  onMouseUp={() => {
                    setDragging(false);
                  }}
                >
                  {/* {!isButtonSubformOpen && emptyScreen && checkEmpty(props?.formdata) && 
                  <div
                    role="region"
                    aria-label="Empty Screen Text Region"
                    id="emptyScreen"
                    // onDrop={(ev) => props.handleReorderDrop(ev, "Design Page")}
                    // onDragOver={(event) => targetForDrop(event)}
                    // onDragLeave={(event)=>props.handleDragLeave(event)}
                    style={{ position: "absolute",width:marvinButtonSelected && !addContainer && generatePage && !matches ? "calc( 100% - 360px)":"100%",height:"100%", left:marvinButtonSelected && !addContainer && generatePage && !matches ? null : "50%", transform: marvinButtonSelected && !addContainer && generatePage && !matches ? null : "translate(-50%, 0px)" }}
                  >
                    <GeneratePage
                      containerId={props?.containerId}
                      handleTemplate={handleTemplate}
                      addContainer={addContainer}
                      setAddContainer={setAddContainer}
                      generatePage={generatePage}
                      setGeneratePage={setGeneratePage}
                      controlSelected={controlSelected}
                      formState2={formState2}
                      activePage={activePage}
                      activeSubForm={activeSubForm}
                      isPortal={isPortal1}
                      isMarvinEnabled={isMarvinEnabled}
                    />
                    {showPageTemplate.open && (
                      <SelectTemplate
                        isTemplate={true}
                        open={showPageTemplate.open}
                        key={showPageTemplate.open}
                        handleTemplate={(arg) => handleTemplate(arg)}
                        handleClose={handleClose}
                        setSelectedTemplateName={setSelectedTemplateName}
                        getAllPages={() => getAllPages("page")}
                        componentFor={"page"}
                        pageProperties={pageProperties}
                      />
                    )}
                  </div>} */}
                  {openCanvasForSubform === "subform" ? (
                    <>
                      {props?.subFormJson?.pageStyle?.["Header"] === "true" ? (
                        <div
                          style={{
                            borderBottom: "1px solid rgb(196, 196, 196)",
                            display: "flex",
                            justifyContent: "space-between",
                            fontFamily: "Open Sans",
                            backgroundColor: `${
                              props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderBackgroundColor"]
                                ? props?.subFormJson?.pageStyle["HeaderBackgroundColor"]
                                : "#ffffff"
                            }`,
                            fontWeight: "600",
                            fontSize: "14px",
                            width: "100%",
                            alignItems: "center",
                            height: "auto"
                          }}
                        >
                          <span
                            style={{
                              fontSize: `${
                                props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontSize"]
                                  ? props?.subFormJson?.pageStyle["HeaderFontSize"]
                                  : "12px"
                              }`
                            }}
                          >
                            {props?.subFormJson?.pageStyle?.["iconFile"] ? (
                              <img
                                style={{
                                  width: "1em",
                                  height: "1em",
                                  marginRight: "10px",
                                  marginLeft: "8px"
                                }}
                                src={`${imageBaseURL}${props?.subFormJson?.pageStyle?.["iconFile"]}${loadArabicImage(imageBaseURL)}`}
                                S
                              />
                            ) : null}
                            <span
                              style={{
                                fontFamily: `${
                                  props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontFamily"]
                                    ? props?.subFormJson?.pageStyle["HeaderFontFamily"]
                                    : "Open Sans"
                                }`,

                                fontWeight: `${
                                  props?.subFormJson?.pageStyle &&
                                  props?.subFormJson?.pageStyle["HeaderFontWeight"]
                                    ? props?.subFormJson?.pageStyle["HeaderFontWeight"]
                                    : "SemiBold"
                                }`,
                                color: `${
                                  props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontColor"]
                                    ? props?.subFormJson?.pageStyle["HeaderFontColor"]
                                    : "#606060"
                                }`,
                                fontStyle: `${
                                  props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontStyle"]
                                    ? props?.subFormJson?.pageStyle["HeaderFontStyle"]
                                    : "SemiBold"
                                }`,
                                margin: "0px 16px"
                              }}
                            >
                              {props.subFormJson &&
                                props.subFormJson?.pageStyle &&
                                props.subFormJson?.pageStyle["SubformTitle"]}
                            </span>
                          </span>

                          <img
                            style={{
                              width: "12px",
                              height: "12px",
                              position: "relative",
                              //  left:"87%",
                              margin: "10px",
                              cursor: "pointer"
                            }}
                            alt="Close Icon"
                            id="closeButton"
                            src={GreyCross}
                          />
                        </div>
                      ) : null}
                    </>
                  ) : null}

                  {openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "showDataAdditonSection" ? (
                    <GridModalHeader
                      gridJSON={currentDesignerGridJson}
                      imageBaseURL={imageBaseURL}
                      extraProps={{ handleCol }}
                    />
                  ) : null}

                  {showDataAdditionSection === "Through Popup" || showDataAdditionSection === "Through Modal" ? (
                    <DataAdditionPopup
                      data={selectedControl}
                      //   {...props}
                      setShowDataAdditionSection={(arg) => setShowDataAdditionSection(arg)}
                    />
                  ) : (
                    <>

                      {props.openCanvasForSubform!=='subform' && props.openCanvasForSubform!=='advanceListviewFromScratch' && props.openCanvasForSubform!=='showDataAdditonSection' && !window.location.pathname.includes("afb_subform") && showLoginHeader.current && (applicationNameObj?.formName !== homePage && activePage?.formId != applicationDataVar?.defaultFormId) && activePage?.formId ? (
                        <LoginHeader
                          data={
                            props.headerJSON
                            // loginHeaderState
                          }
                          activePageFormId={activePage?.formId}
                          activePage={activePage}
                          defaultFormId={applicationDataVar?.defaultFormId}
                          containerId={containerId}
                          previewmode={previewMode}
                          loggedIn={loggedIn}
                          showLoginHeader={showLoginHeader.current}
                          themeData={formState2?.theme}
                        />
                      ) : (
                        <></>
                      )}

                      <div
                        style={{
                          //height:`calc( 100% - 55px )`,
                          height: isGridDesignerSubformOpened
                            ? `calc(100% - ${currentDesignerGridJson?.popupStyle?.["Header"] === "true" ? "90px" : "45px"})`
                            : openCanvasForSubform === "subform"
                            ? "85%"
                            : (formState2?.containerControl === "wizard_h" ||
                                formState2?.containerControl === "wizard_v" ||
                                formState2?.containerControl === "sidenavigation") &&
                              (fixedFooter === false || fixedFooter === "false")
                            ? ""
                            : `100%`,
                          // overflow:
                          //   formState2?.containerControl === "wizard_h" ||
                          //   formState2?.containerControl === "wizard_v" ||
                          //   formState2?.containerControl === "sidenavigation"
                          //     ? "hidden auto"
                          //     : "hidden auto",
                          overflow: "unset",
                          justifyContent: globalLoading ? "center" : "",
                          alignItems: globalLoading ? "center" : "",
                          display: globalLoading ? "flex" : "block",
                          width: globalLoading ? "100%" : "",
                          flexDirection: globalLoading ? "column" : "",
                          backgroundRepeat: "no-repeat",
                          ...formState2?.finalStyles,
                          backgroundImage: "",
                          backgroundColor: currentDesignerGridJson?.popupStyle?.AdvListviewBackgroundColor || "",
                          overflowY: isGridDesignerSubformOpened ? "auto" : null
                        }}
                        ref={imageRef3}
                        id="mainCanvas"
                      >
                        {globalLoading ? (
                          <>
                            <CircularProgress size={30} />
                            <h6 style={{ color: `var(--brand_color2)` }}>{t(globalLoadingMessage)}</h6>
                          </>
                        ) : !isButtonSubformOpen && emptyScreen && checkEmpty(props?.formdata) ? 
                        <div
                    role="region"
                    aria-label="Empty Screen Text Region"
                    id="emptyScreen"
                    // onDrop={(ev) => props.handleReorderDrop(ev, "Design Page")}
                    // onDragOver={(event) => targetForDrop(event)}
                    // onDragLeave={(event)=>props.handleDragLeave(event)}
                    style={{ position: "absolute",width:marvinButtonSelected && !addContainer && generatePage && !matches ? "calc( 100% - 360px)":"100%",height:"100%", left:marvinButtonSelected && !addContainer && generatePage && !matches ? null : "50%", transform: ((marvinButtonSelected && !addContainer && generatePage && !matches) || (showPageTemplate.open)) ? null : "translate(-50%, 0px)" }}
                  >
                    <GeneratePage
                      containerId={props?.containerId}
                      handleTemplate={handleTemplate}
                      addContainer={addContainer}
                      setAddContainer={setAddContainer}
                      generatePage={generatePage}
                      setGeneratePage={setGeneratePage}
                      controlSelected={controlSelected}
                      formState2={formState2}
                      activePage={activePage}
                      activeSubForm={activeSubForm}
                      isPortal={isPortal1}
                      isMarvinEnabled={isMarvinEnabled}
                    />
                    {showPageTemplate.open && (
                      <SelectTemplate
                        isTemplate={true}
                        open={showPageTemplate.open}
                        key={showPageTemplate.open}
                        handleTemplate={(arg) => handleTemplate(arg)}
                        handleClose={handleClose}
                        setSelectedTemplateName={setSelectedTemplateName}
                        getAllPages={() => getAllPages("page")}
                        componentFor={"page"}
                        pageProperties={pageProperties}
                      />
                    )}
                  </div>
                        : props.renderChild}
                      </div>
                    </>
                  )}

                  {props.openScale ? (
                    <div
                      className={styles.wholeClass}
                      style={{ width: `${document.getElementById("mainCanvas").getBoundingClientRect().width}px` }}
                    >
                      <div className={styles.scaleClass}>
                        <label aria-label="0" className={styles.labelClassScale}>
                          0
                        </label>
                        <label aria-label="100" className={styles.labelClassScale}>
                          100
                        </label>
                        <label aria-label="200" className={styles.labelClassScale}>
                          200
                        </label>
                        <label aria-label="300" className={styles.labelClassScale}>
                          300
                        </label>
                        <label aria-label="400" className={styles.labelClassScale}>
                          400
                        </label>
                        <label aria-label="500" className={styles.labelClassScale}>
                          500
                        </label>
                        <label aria-label="600" className={styles.labelClassScale}>
                          600
                        </label>
                        <label aria-label="700" className={styles.labelClassScale}>
                          700
                        </label>
                        <label aria-label="800" className={styles.labelClassScale}>
                          800
                        </label>
                        <label aria-label="900" className={styles.labelClassScale}>
                          900
                        </label>
                        <label aria-label="1000" className={styles.labelClassScale}>
                          1000
                        </label>
                        <label aria-label="1100" className={styles.labelClassScale}>
                          1100
                        </label>
                        <label aria-label="1200" className={styles.labelClassScale}>
                          1200
                        </label>
                        <label aria-label="1300" className={styles.labelClassScale}>
                          1300
                        </label>
                        <label aria-label="1400" className={styles.labelClassScale}>
                          1400
                        </label>
                        <label aria-label="1500" className={styles.labelClassScale}>
                          1500
                        </label>
                        <label aria-label="1600" className={styles.labelClassScale}>
                          1600
                        </label>
                        <label aria-label="1700" className={styles.labelClassScale}>
                          1700
                        </label>
                        <label aria-label="1800" className={styles.labelClassScale}>
                          1800
                        </label>
                      </div>
                    </div>
                  ) : null}

                  {openCanvasForSubform === "subform" && props?.subFormJson?.pageStyle?.["Footer"] === "true" ? (
                    <div
                      style={{
                        borderTop: " 1px solid rgb(196, 196, 196)",
                        // width: "100%",
                        height: "40px",
                        bottom: document.URL.includes("pmWebDesigner") ? "64px" : "55px",
                        position: "fixed",
                        pointerEvents: "none",
                        display: "flex",
                        justifyContent: "end",
                        backgroundColor: `${
                          props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["FooterBackgroundColor"]
                            ? props?.subFormJson?.pageStyle["FooterBackgroundColor"]
                            : "#EBEAE4"
                        }`,
                        zIndex : "2",
                        width : document.querySelector("#mainCanvas")?.getBoundingClientRect()?.width 
                        // left: "0%"
                      }}
                    >
                      {props?.subFormJson?.pageStyle?.["showCancelButton"] === "true" ? (
                        <Button
                          id={props?.userDefinedControlId + "_cancelbtn"}
                          variant="outlined"
                             className={classes.SubformButtonStyleCancel}
                          style={{
                            position: "unset",
                            left: "unset",
                            bottom: "1px",
                            color: `${
                              props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["subformCancelColor"]
                                ? props?.subFormJson?.pageStyle["subformCancelColor"]
                                : "#C4C4C4"
                            }`,
                            borderColor: `${
                              props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["subformCancelColor"]
                                ? props?.subFormJson?.pageStyle["subformCancelColor"]
                                : "#C4C4C4"
                            }`,
                            borderRadius:`${
                props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["subformCornerRadius"] ? 
                 `${props?.subFormJson?.pageStyle["subformCornerRadius"]} !important`:"2px !important"
            }`,
                          }}
                        >
                          Cancel
                        </Button>
                      ) : null}
                      <button variant="contained" className={classes.SubformButtonStyle} style={{ position: "sticky" }}>
                      {props.subFormJson?.pageStyle["subformLabel"] ? 
            (props.subFormJson?.pageStyle["subformLabel"] ) : t(`${"Done"}`)}
                      </button>
                    </div>
                  ) : null}

                  {(openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "showDataAdditonSection") && showFooter && (showFooterWhenDisabled || currentDesignerGridJson?.style?.Enable !== "false") ? (
                      <GridModalFooter
                        gridJSON={currentDesignerGridJson}
                        formState2={formState2} 
                        extraProps={{ loading: false, showOverlayBatchButtonPartial: true, selectedRowIndex: -1 }}
                      />
                  ) : null}
                </Card.Body>
              

              {openCanvasForSubform === "subform" ? (
                <div
                  tabIndex="0"
                  onKeyDown={(e) => handleEscapeKey(e)}
                  style={{
                    direction: translationStyles1 ? "ltr" : "rtl",
                    paddingLeft: translationStyles1 ? "12px" : null,
                    zIndex: 2
                  }}
                  className={styling.subFormButtonsDiv}
                  id="subformId"
                >
                  <div className={styling.subFormButtonsInnerDiv}>
                    <button className={styling.subFormSaveButton} onClick={() => handleSubForm("Save & Close")}>
                      {/* <span className={styling.spanSaveIconA}>

                {formdata && formdata?.pageStyle && preparecss === false ? 
                    <CSSPreparation 
                        stylingData={formdata?.pageStyle} 
                        setStylingData={(stylingData)=> setStylingData(stylingData)}
                    /> 
                    : null
                }
                <Loading containerId={containerId} formState2={formState2}/>

                                <Card.Body 
                                tabIndex="0"
                                onKeyDown={e => handleEscapeKey(e)}
                                    className={ openCanvasForSubform === "subform" || openCanvasForSubform === "advanceListviewFromScratch" ? 
                                        [styles.subformCanvas_body, ...(openCanvasForSubform === "subform" ? [styles.subformCanvas_subformBody] : []),,openCanvasForSubform === "advanceListviewFromScratch" ? css(overlaySyleSheet1.styling): null].join(" ")  : 
                                        [styles.canvas_body].join(" ")
                                    } 
                                    elem_type='Design Page' 
                                    control_id='design_page'
                                    // style={canvas_bodyStyle}
                                    style={{
                                        ...canvas_bodyStyle, 
                                        ...formdata?.pageStyle,
                                        // height: `calc(99vh - ${canvas_bodyHeight.current}px)` , 
                                        overflowY: formState2?.containerControl === "wizard_h" || formState2?.containerControl === "wizard_v" || formState2?.containerControl === "sidenavigation" ? fixedFooter === 'false' || fixedFooter === false ? 'auto' : 'hidden' : 'auto',
                                        minHeight: '400px !important',
                                        // scrollbarWidth : 'none',
                                        backgroundColor:`${openCanvasForSubform === "subform"?
                                        props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["SubformBackgroundColor"] ? props?.subFormJson?.pageStyle["SubformBackgroundColor"]:"#ffffff"
                                        :
                                        "transparent"
                                    }`,
                                   
                                    backgroundImage: `${openCanvasForSubform === "advanceListviewFromScratch" ? "none" : formState2?.finalStyles?.backgroundImage || ""}`,
                                // backgroundColor:formState2?.finalStyles.backgroundColor || "transparent",
                                // backgroundImage: formState2?.finalStyles.backgroundImage || "",
                                    backgroundPositionX: formState2?.finalStyles?.backgroundPositionX,
                                    backgroundPositionY :formState2?.finalStyles?.backgroundPositionY,
                                    backgroundSize: formState2?.finalStyles?.backgroundSize,
                                    backgroundRepeat:"no-repeat",
                                        // backgroundColor:`${props?.subFormJson?.pageStyle["BackgroundColor"]}`
                                        // width:"unset"
                                    border: previewMode ? '0px': '',
                                    display: "inline-table"

                                    }}
                                    // id="canvasbody_id"
                                    id='design_page'
                                    // id="canvasId"
                                    // onDrop={(event)=>drop(event)}
                                    onDrop={(ev)=>props.handleReorderDrop(ev,'Design Page')}
                                    onDragOver={(event)=>targetForDrop(event)}
                                    onClick={(event) =>props.testClick(event)}
                                    onMouseUp={()=>{setDragging(false)}}
                                >
                                    
                                    { openCanvasForSubform === "subform" ? 
                                      <>                                           
                                                {props?.subFormJson?.pageStyle?.["Header"] === "true" ? (
                                                <div style={{
                                                    borderBottom: "1px solid rgb(196, 196, 196)",
                                                      display:"flex",
                                                      justifyContent:"space-between",
                                                    fontFamily: 'Open Sans',
                                                    backgroundColor:`${
                                                    props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderBackgroundColor"] ? props?.subFormJson?.pageStyle["HeaderBackgroundColor"]:"#ffffff"
                                                }`,
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    width:"100%",
                                                    alignItems:"center",
                                                    height: "auto"}} >
                                                        <span  style={{fontSize:`${
                                                    props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontSize"] ? props?.subFormJson?.pageStyle["HeaderFontSize"]:"12px"
                                                }`}}>
                                                        {props?.subFormJson?.pageStyle?.["iconFile"] ? (
                                                   <img
                                                        style={{
                                                            width: "1em",
                                                            height: "1em",
                                                            marginRight: "10px",
                                                            marginLeft: "8px"
                                                        }}
                                                        src={`${imageBaseURL}${props?.subFormJson?.pageStyle?.["iconFile"]}`}
                                                    S/>
                                                      ) : null}
                                            <span style={{
                                                fontFamily:`${
                                                    props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontFamily"] ? props?.subFormJson?.pageStyle["HeaderFontFamily"]:"Open Sans"
                                                }`,
                                               
                                                fontWeight:`${
                                                    props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontStyleWeight"] ? props?.subFormJson?.pageStyle["HeaderFontStyleWeight"]:"SemiBold"
                                                }`,
                                                color:`${
                                                    props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontColor"] ? props?.subFormJson?.pageStyle["HeaderFontColor"]:"#606060"
                                                }`,
                                                fontStyle:`${
                                                    props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontStyle"] ? props?.subFormJson?.pageStyle["HeaderFontStyle"]:"SemiBold"
                                                }`,
                                                
                                            }}>
                                            {props.subFormJson && props.subFormJson?.pageStyle && props.subFormJson?.pageStyle["SubformTitle"]}
                                            </span>
                                                        </span>
                                                 
                                            <img
                                                style={{
                                                 width: "12px",
                                                   height: "12px",
                                                  position:"relative",
                                                //  left:"87%",
                                                margin:"10px",
                                                cursor: "pointer",
                                                  }}
                                                  alt="Close Icon"
                                                 id="closeButton"
                                                src={GreyCross}
                                                    />
                                                </div>
                                                ):null}
                                               
                                      </> : null 
                                    }

                                    { showDataAdditionSection === "Through Popup" ? 
                                        <DataAdditionPopup 
                                            data={selectedControl} 
                                            //   {...props}
                                            setShowDataAdditionSection={(arg)=>setShowDataAdditionSection(arg)}
                                        />  
                                    : 
                                        <>
                                            { (props.openCanvasForSubform!=='subform' && props.openCanvasForSubform!=='advanceListviewFromScratch' && props.openCanvasForSubform!=='showDataAdditonSection') ?
                                                <LoginHeader 
                                                    data={
                                                        props.headerJSON
                                                        // loginHeaderState
                                                    } 
                                                    activePageFormId={activePage?.formId}
                                                    activePage={activePage}
                                                    defaultFormId={applicationDataVar?.defaultFormId}
                                                    containerId={containerId}
                                                    previewmode={previewMode} 
                                                    loggedIn={loggedIn} 
                                                    showLoginHeader={showLoginHeader.current} 
                                                    themeData={formState2?.theme}
                                                /> : <></>
                                            }
                                        
                                            <div 
                                                style={{
                                                    //height:`calc( 100% - 55px )`,
                                                    height: openCanvasForSubform === "advanceListviewFromScratch" ? "calc(100% - 80px)" : openCanvasForSubform === "subform" ? '85%' : (formState2?.containerControl === "wizard_h" || formState2?.containerControl === "wizard_v" || formState2?.containerControl === "sidenavigation") && (fixedFooter === false || fixedFooter === 'false') ?  '': `100%`,
                                                    overflow:formState2?.containerControl === "wizard_h" || formState2?.containerControl === "wizard_v" || formState2?.containerControl === "sidenavigation" ? 'hidden auto' : "hidden auto",
                                                    overflow: "unset",
                                                    justifyContent: globalLoading ? "center" : "",
                                                    alignItems:globalLoading ? "center" : "",
                                                    display: globalLoading ? "flex" : "block",
                                                    width: globalLoading ? "100%" : "",
                                                    flexDirection:globalLoading ?"column" : "",
                                                    backgroundRepeat:"no-repeat",
                                                    ...(openCanvasForSubform ? {} : formState2?.finalStyles),
                                                    backgroundImage:"",
                                                    backgroundColor: openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.popupStyle?.AdvListviewBackgroundColor : ""
                                                }}
                                                ref={imageRef3}
                                                id="mainCanvas"
                                            >
                                              {globalLoading ? <><CircularProgress size={30}/> 
                                              <h6 style={{color:`var(--brand_color2)`}}>{t(globalLoadingMessage)}</h6>
                                              </>: <ELEMENT
                                                    previewmode={previewMode}
                                                    containerId={containerId}
                                                    {...props} 
                                                    // data={openCanvasForSubform === "subform" ? props.subFormJson : formdata}
                                                    formdata1={formdata1}
                                                    data={openCanvasForSubform === "subform" ? props.subFormJson 
                                                        : openCanvasForSubform === "advanceListviewFromScratch" ?  props.advanceListviewStateJson 
                                                        : openCanvasForSubform === "showDataAdditonSection" ? props.subFormListviewJson  
                                                        : formdata 
                                                    }
                                                    // data={(openCanvasForSubform === "showDataAdditonSection" || openCanvasForSubform === "advanceListviewFromScratch") ? props.subFormJson : formdata}
                                                    openCanvasForSubform={props.openCanvasForSubform}
                                                    showDataAdditionSection={showDataAdditionSection}
                                                    setShowDataAdditionSection={(arg)=>setShowDataAdditionSection(arg)}
                                                /> }  
                                            </div>
                                        </>
                                    }

                                    {props.openScale ? 
                                        <div className={styles.wholeClass} style={{width: `${document.getElementById("mainCanvas").getBoundingClientRect().width}px`}}>
                                            <div className={styles.scaleClass}>
                                                <label aria-label='0' className={styles.labelClassScale} >0</label>
                                                <label aria-label='100' className={styles.labelClassScale} >100</label>
                                                <label aria-label='200' className={styles.labelClassScale} >200</label>
                                                <label aria-label='300' className={styles.labelClassScale} >300</label>
                                                <label aria-label='400' className={styles.labelClassScale} >400</label>
                                                <label aria-label='500' className={styles.labelClassScale} >500</label>
                                                <label aria-label='600' className={styles.labelClassScale} >600</label>
                                                <label aria-label='700' className={styles.labelClassScale} >700</label>
                                                <label aria-label='800' className={styles.labelClassScale} >800</label>
                                                <label aria-label='900' className={styles.labelClassScale} >900</label>
                                                <label aria-label='1000' className={styles.labelClassScale} >1000</label>
                                                <label aria-label='1100' className={styles.labelClassScale} >1100</label>
                                                <label aria-label='1200' className={styles.labelClassScale} >1200</label>
                                                <label aria-label='1300' className={styles.labelClassScale} >1300</label>
                                                <label aria-label='1400' className={styles.labelClassScale} >1400</label>
                                                <label aria-label='1500' className={styles.labelClassScale} >1500</label>
                                                <label aria-label='1600' className={styles.labelClassScale} >1600</label>
                                                <label aria-label='1700' className={styles.labelClassScale} >1700</label>
                                                <label aria-label='1800' className={styles.labelClassScale} >1800</label>
                                            </div>
                                        </div>
                                        : null
                                    }
                                         { openCanvasForSubform === "subform" && props?.subFormJson?.pageStyle?.["Footer"] === "true" ?  
                                      (
                                                <div  style={{ borderTop:" 1px solid rgb(196, 196, 196)",
                                                   width: "100%",
                                                   height: "40px",
                                                   bottom:"0px",
                                                   position: "absolute",
                                                   pointerEvents:"none",
                                                   display:"flex",
                                                   justifyContent:"end",
                                                   backgroundColor:`${
                                                    props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["FooterBackgroundColor"] ? props?.subFormJson?.pageStyle["FooterBackgroundColor"]:"#EBEAE4"
                                                }`,
                                                    left: "0%"}}>
                                                { props?.subFormJson?.pageStyle?.["showCancelButton"] === "true" ? 
                                               
                                               <Button
                                               id={props?.userDefinedControlId + "_cancelbtn"}
                                                variant="outlined" 
                                            //    className={classes.SubformButtonStyleCancel} 
                                               style={{position:"unset",left:"unset",bottom:"1px",
                                               color:`${
                                                props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["subformCancelColor"] ? props?.subFormJson?.pageStyle["subformCancelColor"]:"#C4C4C4"
                                            }`,
                                            borderColor:`${
                                                props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["subformCancelColor"] ? props?.subFormJson?.pageStyle["subformCancelColor"]:"#C4C4C4"
                                            }`,}}
                                               >Cancel</Button>
                                                 : null}
                                                    <button variant="contained" className={classes.SubformButtonStyle} style={{position:"sticky"}}>
                                                {t(`${"Done"}`)}
                                               
                                                </button> 
                                                </div>
                                       ) : null 
                                    }
                                </Card.Body>

                {openCanvasForSubform === "subform" ?
                    <div tabIndex="0" onKeyDown={(e) => handleEscapeKey(e)} style={{direction: translationStyles1 ? "ltr" : "rtl", paddingLeft: translationStyles1 ? "12px" : null}} className={styling.subFormButtonsDiv} id="subformId">
                        <div className={styling.subFormButtonsInnerDiv}>
                        <button 
                                className={styling.subFormSaveButton} 
                                onClick={()=>handleSubForm("Save & Close")}
                            >
                                {/* <span className={styling.spanSaveIconA}>

                                    <SvgDownloadIcon/>
                                </span> */}
                      {t(`${"Save & Close"}`)}
                    </button>
                    <button className={styling.subFormDownloadButton} onClick={() => handleSubForm("Save")}>
                      <span className={styling.spanDownloadIconA}>
                        <SaveIcon />
                      </span>
                      {t(`${"Save Changes"}`)}
                    </button>

                    <button className={styling.subFormDownloadButton} onClick={() => handleSubForm("Download")}>
                      <span className={styling.spanDownloadIconA}>
                        <SvgDownloadIcon />
                      </span>
                      {t(`${"Download"}`)}
                    </button>
                    <button className={styling.subFormCancelButton}
                    style={{
                      
                    }} onClick={() => handleSubForm("Cancel")}>
                      {t("Cancel")}
                    </button>
                  </div>
                </div>
              ) : null}
              {openCanvasForSubform === "advanceListviewFromScratch" ? (
                <div
                  tabIndex="0"
                  onKeyDown={(e) => handleEscapeKey(e)}
                  style={{
                    direction: translationStyles1 ? "ltr" : "rtl",
                    paddingLeft: translationStyles1 ? "12px" : null
                  }}
                  className={styling.subFormButtonsDiv}
                  id="advanceListviewFromScratchId"
                >
                  <div className={styling.subFormButtonsInnerDiv}>
                    <button className={styling.subFormSaveButton} onClick={() => handleSubForm("Save listviewOverlay")}>
                      {t(`${"Save Changes"}`)}
                      <span className={styling.spanSaveIconA}>
                        <SvgSaveIcon />
                      </span>
                    </button>

                    <button className={styling.subFormSaveButton} onClick={() => handleSubForm("Save & Close Advance")}>
                      {t(`${"Save & Close"}`)}
                    </button>

                    {/* <button className={styling.subFormDownloadButton} onClick={() => handleSubForm("DownloadAdv")}>
                  {t(`${"Download"}`)}
                  <span className={styling.spanDownloadIconA}>
                    <SvgDownloadIcon />
                  </span>
                </button> */}

                    <button className={styling.subFormCancelButton} onClick={() => handleSubForm("Cancel Advance")}>
                      {t("Cancel")}
                    </button>
                  </div>
                </div>
              ) : null}
              {openCanvasForSubform === "showDataAdditonSection" ? (
                <div
                  className={styling.subFormButtonsDiv}
                  style={{
                    direction: translationStyles1 ? "ltr" : "rtl",
                    paddingLeft: translationStyles1 ? "12px" : null
                  }}
                >
                  <div className={styling.subFormButtonsInnerDiv}>
                    <button className={styling.subFormSaveButton} onClick={() => handleSubForm("Save Listview")}>
                      <span className={styling.spanSaveIconA}>
                        <SvgSaveIcon />
                      </span>
                      {t(`${"Save Changes"}`)}
                    </button>
                    <button className={styling.subFormCancelButton} onClick={() => handleSubForm("Cancel Listview")}>
                      {t("Cancel")}
                    </button>
                  </div>
                </div>
              ) : null}
            </Card>
            {props?.OpenPicklistValidationModal && props?.validationResponse.length > 0 && (
              <PicklistValidationModal
                setOpenPicklistValidationModal={props?.setOpenPicklistValidationModal}
                validationResponse={props?.validationResponse}
                formdata={formState2}
              />
            )}
          </>
        );
    }
}

export default Canvas